import React from "react";
import GridItem from "components/Grid/GridItem.jsx";
import GridContainer from "components/Grid/GridContainer.jsx";
import Box from "@material-ui/core/Box";
import CloseIcon from "@material-ui/icons/Close";
import {
  IconButton,
  Link as MaterialLink,
  LinearProgress,
  Typography,
} from "@material-ui/core";
import SwitchToggle from "components/SwitchToggle/SwitchToggle";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import { FormErrors } from "../../../components/Login/FormErrors";
import { userService } from "_services/user.service";
import enMsg from "__helpers/locale/en/en";
import PhoneNumber from "awesome-phonenumber";
import ConfirmModal from "components/Modal/modal";
import Icon from "@material-ui/core/Icon";
import InputBase from "@material-ui/core/InputBase";
import SearchIcon from "@material-ui/icons/Search";
import Tooltip from "@material-ui/core/Tooltip";
import { apiPath } from "api";
import {
  generalAuthTokenHeader,
  generalMimeAuthTokenHeader,
} from "__helpers/auth-header";
import {
  countsFromContactList,
  indexCountsByPatient,
  inviteButtonLabel
} from "__helpers/inviteLabel";
import {
  Table,
  TableHead,
  TableBody,
  TableCell,
  TableRow,
  TableSortLabel,
  TablePagination,
} from "@material-ui/core";
import {
  PER_PAGE_OPTIONS,
  DEFAULT_PER_PAGE_RECORDS,
  ONLY_NUMBER_REGEX,
  MAX_INPUT_LENGTH,
  ALLOWED_FACESHEET_EXTENTION,
  ALLOWED_FACESHEET_SIZE,
  MULTIPLE_PATIENT_LIST,
  PATIENT_ORDERBY,
  DP_DASHBOARD_FILTERS,
  MAXMRJ_FACILITY,
  VENDOR_FACILITY,
  getStatusDisplayLabel,
} from "__helpers/constants";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  TextField,
  Slide,
  List,
  ListItem,
  ListItemSecondaryAction,
  ListItemText,
  withStyles,
} from "@material-ui/core";
import DeleteIcon from "@material-ui/icons/Delete";
import GetAppIcon from "@material-ui/icons/GetApp";
import JSZip from "jszip";
import { saveAs } from "file-saver";
import BlockIcon from "@material-ui/icons/Block";
import SelectStatus from "components/SelectStatus/selectStatus";
import CircularProgress from "@material-ui/core/CircularProgress";
import CategoriesList from "./CategoriesList";
import ContactDialog from "../SinglePatientDetail/ContactDialog";
import DashboardTour from "components/DashboardTour/DashboardTour";
import maxAllyIcon from "assets/img/icons/maxally-icon.svg";
import ImportPatientModal from "../ImportPatients";
import { basePath, baseRoutes, dpBaseRoutes } from "base-routes";
import { FormGroup, FormControl, InputLabel } from "@material-ui/core";
import { Link, NavLink } from "react-router-dom";
import Select from "@material-ui/core/Select";
import Input from "@material-ui/core/Input";
import MenuItem from "@material-ui/core/MenuItem";
import { PATIENT_SORT, PATIENT_FILTER } from "__helpers/constants";
import done from "assets/img/done.svg";

import Container from "@material-ui/core/Container";
import ListItemAvatar from "@material-ui/core/ListItemAvatar";
import Checkbox from "@material-ui/core/Checkbox";
import logo from "assets/img/front-logo.png";
import ScrollMenu from "react-horizontal-scrolling-menu";
import "./patientDashboardCss.css";
// Imported after patientDashboardCss so the redesign wins on equal specificity.
import "./patientDirectory.css";
import InfiniteScroll from "react-infinite-scroller";
import {
  MuiPickersUtilsProvider,
  KeyboardDatePicker,
} from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import { connect } from "react-redux";
import { reduxLoad } from "js/actions/index";

import Chip from "@material-ui/core/Chip";
import CircleChecked from "@material-ui/icons/CheckCircleOutline";
import CircleCheckedFilled from "@material-ui/icons/CheckCircle";
import CircleUnchecked from "@material-ui/icons/RadioButtonUnchecked";

import leftArrow from "assets/img/icons/arrorw1.svg";
import rightArrow from "assets/img/icons/arrow2.svg";
import { ALLOWED_PROFILE_IMAGE_SIZE } from "__helpers/constants";
import { ALLOWED_IMAGE_EXTENTION } from "__helpers/constants";
import fileExtension from "file-extension";
import infoIcon from "assets/img/icons/info-icon.svg";
import tasksImg from "assets/img/icons/tasksImg.png";
import { REDUX_STATE_DATA } from "__helpers/constants";

// own carosoul
// import React from 'react';
import "owl.carousel/dist/assets/owl.carousel.css";
import "owl.carousel/dist/assets/owl.theme.default.css";
import { PATIENT_LIST } from "__helpers/constants";
import { USER_INFO } from "__helpers/constants";
import ChangePassword from "views/Profile/ChangePassword";
import BAAComponent from "views/CmsPages/BAAComponent";
import TermsComponent from "views/CmsPages/TermsComponent";
// import 'react-owl-carousel2/style.css';
import { Scrollbars } from "react-custom-scrollbars";
import { SELECTED_PATIENT_LIST } from "__helpers/constants";
import { getActiveFacility, getActiveFacilityId } from "__helpers/activeFacility";
import Files from "react-files";
import moment from "moment-timezone";
import TasksList from "./TasksList";
import PatientTasks from "../SinglePatientDetail/PatientTasks";
import WarningIcon from "@material-ui/icons/Warning";
import { daysBetweenTwoDate } from "__helpers/util";
import { localDateFormat } from "__helpers/util";
import { localServerFormat } from "__helpers/util";

function mapDispatchToProps(dispatch) {
  return {
    reduxLoad: (reduxLoadVal) => dispatch(reduxLoad(reduxLoadVal)),
  };
}
const mapStateToProps = (state) => {
  return {
    userInfoRedux: state.userInfo,
    categoryListRedux: state.categoryList,
    insuranceListRedux: state.insuranceList,
    patientStatusListRedux: state.patientStatusList,
    hospitalListRedux: state.hospitalList,
    patientFilterListRedux: state.patientFilterList,
    timestampRedux: state.timestamp,
    reduxLoadFlag: state.reduxLoadFlag,
  };
};

const Transition = React.forwardRef(function Transition(props, ref) {
  return <Slide direction="right" ref={ref} {...props} />;
});

// One item component
// selected prop will be passed
const CategotyMenuItem = ({ keyVals, cListVals }) => {
  const { masterCategories, catagoryId, status } = cListVals;
  return (
    <Box className="item menu-item" key={keyVals} border={1}>
      <p className="category-value">{masterCategories.categoryValue}</p>
      <p className="category-status">{masterCategories.status}Awaiting</p>
    </Box>
  );
};
// All items component
// Important! add unique key
export const CategotyMenu = (list, selected, categoryList) =>
  list.map((el, key) => {
    const { name } = el;

    return (
      <CategotyMenuItem
        cListVals={el}
        text={name}
        key={key}
        selected={selected}
        categoryList={categoryList}
      />
    );
  });

const CategotyArrow = ({ text, className }) => {
  return (
    <div className={className}>
      <img src={text} />
    </div>
  );
};

const ArrowLeft = CategotyArrow({ text: leftArrow, className: "arrow-prev" });
const ArrowRight = CategotyArrow({ text: rightArrow, className: "arrow-next" });

/**
 * Patient Dashboard tabs. `key` is sent to the backend as ?tab= and owns the membership rule:
 *   DASHBOARD  - upcoming discharge within 14 days, plus anything a DP pinned on
 *   ALL        - every imported patient of the facility
 *   NEW        - no admission date
 *   CURRENT    - admitted, not yet discharged
 *   DISCHARGED - has an actual discharge date
 */
/**
 * "Discharged in the last N days" pills, shown only on the Discharged tab.
 *
 * Sent as ?dischargedWithinDays= and evaluated server-side against
 * actual_discharge_date, so paging and the total count stay correct. Not the old
 * filterBy discharge ids (13/14): those are forward-looking on the ESTIMATED
 * discharge date, which PCC never sends.
 *
 * `days: 0` is the All pill — the backend treats null/0 as no filter.
 */
/** Default window on the Discharged tab. "All" stays selectable, it is just not the landing state. */
const DISCHARGED_WITHIN_DEFAULT = 30;

const DISCHARGED_WITHIN_FILTERS = [
  { days: 0, label: "All" },
  { days: 7, label: "Last 7 days" },
  { days: 14, label: "Last 14 days" },
  { days: 30, label: "Last 30 days" },
];

/**
 * Insurance Type pills, shown on every tab (unlike the Discharged window above).
 *
 * Options are All plus the master_insurance_type catalogue, fetched at mount rather than
 * hardcoded — the client owns that list and there is no CRUD for it, so the seed can change
 * without a frontend release. Sent as ?insuranceTypeId= and resolved server-side through
 * jhi_patient.insurance_id -> master_insurance.insurance_type, so paging and the total count
 * stay correct.
 *
 * `0` is the All pill; the backend treats null/0 as no filter. Patients with no insurance, or
 * whose insurance has no type set, match no pill and appear only under All.
 */
const INSURANCE_TYPE_ALL = 0;

/**
 * `manual: true` marks the tabs a non-PCC (hand-entered) facility gets.
 *
 * Only Dashboard and All. New / Current / Discharged key off admission_date, which is
 * populated only from the PCC import record — the Add Patient form never captures it, so
 * for a hand-entered patient it is always null. That would put every manual patient in New
 * forever and leave Current permanently empty. Discharged would technically work (the form
 * does capture a discharge date) but is not worth a tab on its own; add `manual: true` to
 * it if the client asks.
 */
const PATIENT_TABS = [
  { key: "DASHBOARD", label: "Dashboard", manual: true },
  { key: "ALL", label: "All Patients", manual: true },
  { key: "NEW", label: "New" },
  { key: "CURRENT", label: "Current" },
  { key: "DISCHARGED", label: "Discharged" },
];

// jhi_patient.manual_dashboard_status — see DashboardStatus.java.
//   0 AUTO (untouched)  1 ADDED  2 REMOVED
// Dashboard membership is ADDED only. auto_dashboard_status is deliberately NOT read here:
// the nightly job that maintained it keyed off the estimated discharge date, which PCC does
// not send, so the job is disabled and the column's contents are stale.
const MANUAL_ADDED = 1;
const MANUAL_REMOVED = 2;

const selected = "item1";
const options = {
  //items: 3,
  nav: true,
  rewind: true,
  autoplay: false,
};
const tooltipStyles = {
  tooltip: {
    width: "auto !important",
    // height: "36px",
    borderRadius: "18px",
    boxShadow: "0 20px 80px 0",
  },
};
const CustomTooltip = withStyles(tooltipStyles)(Tooltip);

moment.tz.setDefault("UTC");
class PatientListClass extends React.Component {
  /** Monotonic id for patient-list fetches; only the newest response may write state. */
  fetchSeq = 0;

  // Same guard as fetchSeq, for the checkbox selection rather than the list fetch.
  // Ticking a patient fires a per-patient GET; ticking a second one before that lands
  // used to let the first RESPONSE overwrite multiplePatientList with just its own id,
  // silently unchecking the second patient. Bumped on every tick, captured by
  // fetchPatientInfo, and checked before that response writes any selection state.
  selectionSeq = 0;
  /** Debounce handle for as-you-type search. */
  searchDebounce = null;

  inputOpenImageFileRef = React.createRef(null);
  inputOpenFaceSheetFileRef = React.createRef(null);
  maxDate = new Date();
  minDate = new Date();
  constructor(props) {
    super(props);
    let spinner = document.getElementById("loadingSpinner");
    // let patientList = JSON.parse(localStorage.getItem(PATIENT_LIST));
    let userInfo = JSON.parse(localStorage.getItem(USER_INFO));
    let patientList = JSON.parse(sessionStorage.getItem('_patient_list'));
    //console.log("datapatientList",patientList[0].patientId);
    // Org Admin: facilityCode comes from the active facility (no dischargePlanner row).
    // Use the per-tab resolver (sessionStorage, captured from the URL at load) so it survives
    // in-tab navigation that drops the query string (e.g. the MAXMRJ Home icon). Plain DPs /
    // Facility Admins still fall back to their own dischargeplanner facility code below.
    let urlFacilityCode = null;
    try {
      const af = getActiveFacility();
      urlFacilityCode = af && af.facilityCode ? af.facilityCode : null;
    } catch (e) {
      urlFacilityCode = null;
    }
    let dpFacilityCode =
      urlFacilityCode
        ? urlFacilityCode
        : userInfo &&
          userInfo.dischargePlanner &&
          userInfo.dischargePlanner.facility &&
          userInfo.dischargePlanner.facility.facilityCode
          ? userInfo.dischargePlanner.facility.facilityCode
          : null;
    const patientCategoryList = ["1", "3"];
    this.dateUtility = new DateFnsUtils();
    this.patientImageName = "";
    this.patientImageBlob = null;
    this.patientFaceSheetName = "";
    this.patientFaceSheetBlob = null;
    this.state = {
      loading: false,
      // Patient Dashboard tab. All five render this same screen — listing, search, filters,
      // click-through to the patient — and differ only in the membership rule the backend
      // applies behind ?tab=.
      activeTab: PATIENT_TABS[0].key,
      // Discharged tab only: 0 = All, else the window in days. Defaults to 30 — a
      // facility's full discharge history is rarely what a DP wants to open on, and
      // the unbounded list is the slowest query on the screen. Reset to 30 on tab
      // change, since the control does not exist outside that tab.
      dischargedWithinDays: DISCHARGED_WITHIN_DEFAULT,
      // Insurance Type pill row (all tabs). 0 = All. The catalogue is loaded at mount.
      insuranceTypeId: INSURANCE_TYPE_ALL,
      insuranceTypeList: [],
      // Patient ids with a "Show on Dashboard" write in flight, so the switch can be disabled
      // and a double-click cannot fire two conflicting writes.
      savingDashboardIds: [],
      // Bulk "Remove from Dashboard" (Dashboard tab only) — confirm dialog + in-flight guard.
      removeFromDashboardConfirmOpen: false,
      removingFromDashboard: false,
      modalStatus: false,
      confirmModalStatus: false,
      confirmModalMessage: "",
      perPage: DEFAULT_PER_PAGE_RECORDS,
      total: 0,
      selectionCount: 0,
      currentPage: 0,
      totalPatientShowing: 0,
      // sorting: "desc",
      sorting: "10",
      // filter: "createdDate",
      filter: "",
      loadingPatient: true,
      loadingState: false,
      items: 10,
      patientSearchKeyword: "",
      direction: true, //true means asc and false means desc
      spinner: spinner,
      isDelete: false,
      tasks: "",
      formErrors: {
        firstName: "",
        lastName: "",
        primaryDiagnosis: "",
        reasonForSnfStay: "",
        middleName: "",
        gender: "",
        insurance: "",
        hospital: "",
        dob: "",
        estDate: "",
        actualEstDate: "",
        patientCategoties: "",
        patientImage: "",
        patientFaceSheet: "",
        benefitDaysRemaining: "",
      },
      firstNameValid: false,
      lastNameValid: false,
      middleNameValid: true,
      genderValid: false,
      primaryDiagnosisValid: false,
      reasonForSnfStayValid: false,
      insuranceValid: true,
      hospitalValid: true,
      dobValid: false,
      estDateValid: true,
      actualEstDateValid: true,
      patientCategotiesValid: true,
      patientImageValid: true,
      patientFaceSheetValid: true,
      benefitDaysRemainingValid: true,

      patientName: "unknown",
      selectedPatientId: "",
      patientCategoryList: [],
      patientList: [],
      //     patientId:patientList[0].patientId,
      categoryList: props.categoryListRedux ? props.categoryListRedux : [],
      insuranceList: props.insuranceListRedux ? props.insuranceListRedux : [],
      hospitalList: props.hospitalListRedux ? props.hospitalListRedux : [],
      patientFilterList: props.patientFilterListRedux
        ? props.patientFilterListRedux
        : [],
      patientStatusList: props.patientStatusListRedux
        ? props.patientStatusListRedux
        : [],
      userInfo: props.userInfoRedux ? props.userInfoRedux : {},
      // MaxAlly invite, opened from the INVITE button on a patient row. One dialog for the
      // whole page — mounting a ContactDialog per row would mean 40 of them.
      openContactDialog: false,
      contactList: [],
      contactPatient: null,
      // MaxAlly invite progress, keyed by patient id, for the Invite button
      // label. Loaded after the rows render; until then the button reads
      // plainly "INVITE".
      contactCounts: {},
      // Onboarding tour for the redesigned dashboard. Held null until the backend says
      // this user has not seen it AND the screen is actually ready to be pointed at.
      tourSteps: null,
      loadMore: false,
      firstName: "",
      lastName: "",
      middleName: "",
      primaryDiagnosis: "",
      reasonForSnfStay: "",
      insurance: "0",
      hospital: "",
      gender: "",
      dob: null,
      estDate: null,
      actualEstDate: null,
      benefitDaysRemaining: "",
      patientCategories: [],
      reduxLoadFlag: false,
      patientTaskCount: 0,
      loadPatient: true,
      selectedPatientData: {},
      openModal: false,
      bbaCondition: false,
      termNcondition: false,
      openTaskModal: false,
      patientImage: "",
      patientFaceSheet: "",
      patientImageName: "",
      patientFaceSheetName: "",
      isImage: false,
      isFaceSheet: false,
      isImageAdded: false,
      isFaceSheetAdded: false,
      patientImages: [],
      patientFaceSheets: [],
      patientImagesStr: [],
      patientFaceSheetsStr: [],
      patientUploadHistory: [],
      patientTaskId: "",
      patientTaskList: [],
      patientTaskGroup: [],
      multiPatientMode: false,
      multiplePatientObj: [],
      multiplePatientList: [],
      selectRemovePatient: [],
      dpFacilityCode: dpFacilityCode,
      facilityType: dpFacilityCode ? VENDOR_FACILITY : MAXMRJ_FACILITY,
      importModal: false,
      isUpdating: false,
    };
    this.handleSubmit = this.handleSubmit.bind(this);
    this.updatePatient = this.updatePatient.bind(this);
    this.createPatient = this.createPatient.bind(this);
    this.fetchPatients = this.fetchPatients.bind(this);
    // this.confirmModalSubmit = this.confirmModalSubmit.bind(this);
    this.search = this.search.bind(this);
    this.searchReturn = this.searchReturn.bind(this);
    this.loadMorePatient = this.loadMorePatient.bind(this);
    this.handlePatientSorting = this.handlePatientSorting.bind(this);
    this.handleSingleDpDChange = this.handleSingleDpDChange.bind(this);
    this.handleImageSelectedFile = this.handleImageSelectedFile.bind(this);
    this.handleFaceSheetSelectedFile = this.handleFaceSheetSelectedFile.bind(
      this
    );
    this.handleEstDateError = this.handleEstDateError.bind(this);
    this.handleDobError = this.handleDobError.bind(this);
    this.imageFilesRemoveAll = this.imageFilesRemoveAll.bind(this);
    this.imageFilesRemoveOne = this.imageFilesRemoveOne.bind(this);
    this.onImageFilesChange = this.onImageFilesChange.bind(this);
    this.onImageFilesError = this.onImageFilesError.bind(this);
    this.onFaceSheetFilesChange = this.onFaceSheetFilesChange.bind(this);
    this.onFaceSheetFilesError = this.onFaceSheetFilesError.bind(this);
    this.fileSelectClick = this.fileSelectClick.bind(this);
    this.middleHandleFn = this.middleHandleFn.bind(this);
    this.fetchPatientInfo = this.fetchPatientInfo.bind(this);
    this.fetchPatientList = this.fetchPatientList.bind(this);
    this.loaderStatus = this.loaderStatus.bind(this);
    this.handleBAAAgree = this.handleBAAAgree.bind(this);
    this.handleTNCAgree = this.handleTNCAgree.bind(this);
    this.uploadImages = this.uploadImages.bind(this);
    this.deleteImages = this.deleteImages.bind(this);
    this.callFetchPateintMethod = this.callFetchPateintMethod.bind(this);
    this.confirmModalClose = this.confirmModalClose.bind(this);
    this.confirmModalSubmit = this.confirmModalSubmit.bind(this);
    this.closeImportModal = this.closeImportModal.bind(this);
    this.handleAssignedSuccess = this.handleAssignedSuccess.bind(this);
    this.handleRemovedSuccess = this.handleRemovedSuccess.bind(this);
    this.categorySelection = this.categorySelection.bind(this);
    this.openPatientPopup = this.openPatientPopup.bind(this);
    this.fetchTasks = this.fetchTasks.bind(this);
  }
  handleClose() { }
  componentDidMount() {

    localStorage.removeItem(SELECTED_PATIENT_LIST);

    this.setState({
      selectedPatientId: "",
      selectedPatientData: {},
      selectionCount: 0,
      multiPatientMode: false,
      multiplePatientList: [],
    });
    let user = JSON.parse(localStorage.getItem(USER_INFO));
    if (!user.termNcondition) {
      this.setState({
        openModal: false,
        termNcondition: true,
        bbaCondition: false,
      });
    } else if (!user.termNcondition) {
      this.setState({
        openModal: false,
        termNcondition: false,
        bbaCondition: true,
      });
    } else {
      if (user.newUser) {
        this.setState({
          openModal: true,
          termNcondition: false,
          bbaCondition: false,
        });
      } else {
        this.setState({
          openModal: false,
          termNcondition: false,
          bbaCondition: false,
        });
      }
    }
    let dpDashboardFilter = JSON.parse(
      localStorage.getItem(DP_DASHBOARD_FILTERS)
    );
    this.setState(
      {
        sorting:
          dpDashboardFilter && dpDashboardFilter.sorting
            ? dpDashboardFilter.sorting
            : "10",
        // Always "", never the persisted value. The STATUS row was the only control
        // for this filter and it has been removed, so restoring a saved value would
        // leave a DP who had picked e.g. "Planning" with a silently filtered list and
        // no way to clear it. Restore this line if a status control ever comes back.
        filter: "",
        patientSearchKeyword:
          dpDashboardFilter && dpDashboardFilter.patientSearchKeyword
            ? dpDashboardFilter.patientSearchKeyword
            : "",
      },
      () => this.fetchPatients()
    );
    this.fetchInsuranceTypes();
    // if (this.props.location && this.props.location.state && this.props.location.state.resetDashboard) {
    //     this.fetchPatients();
    // }
  }

  /**
   * Insurance type catalogue for the pill row. Read-only and seeded, so a failure here is not
   * worth a notification — the row just falls back to the All pill and the list is unfiltered.
   */
  fetchInsuranceTypes = async () => {
    try {
      const response = await fetch(apiPath.insuranceTypes, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });
      if (!response.ok) {
        return;
      }
      const data = await response.json();
      if (Array.isArray(data)) {
        this.setState({ insuranceTypeList: data });
      }
    } catch (error) {
      console.error("Error fetching insurance types", error);
    }
  };

  /**
   * An insurance type pill was clicked. Same reset as the discharged pills: paging, selection
   * and the right-hand panel. Clicking the active pill returns to All.
   */
  handleInsuranceTypeFilter = (insuranceTypeId) => {
    const next =
      this.state.insuranceTypeId === insuranceTypeId
        ? INSURANCE_TYPE_ALL
        : insuranceTypeId;
    this.setState(
      {
        insuranceTypeId: next,
        currentPage: 0,
        patientList: [],
        selectedPatientId: "",
        selectedPatientData: {},
        selectRemovePatient: [],
        multiplePatientList: [],
        multiPatientMode: false,
        selectionCount: 0,
      },
      () => this.fetchPatients()
    );
  };
  handleBAAAgree() {
    let user = JSON.parse(localStorage.getItem(USER_INFO));
    user.termNcondition = true;
    user.bbaCondition = true;
    localStorage.setItem(USER_INFO, JSON.stringify(user));
    if (user.newUser) {
      this.setState({
        openModal: true,
        termNcondition: false,
        bbaCondition: false,
      });
    } else {
      this.setState({
        openModal: false,
        termNcondition: false,
        bbaCondition: false,
      });
    }
  }
  showImportModalLock = () => {
    if (!this.state.selectedPatientId || this.state.multiPatientMode) {
      this.setState({
        confirmModalMessage:
          this.state.selectionCount === this.state.selectRemovePatient.length
            ? "Do you want to remove selected " +
            this.state.selectRemovePatient.length +
            " patient(s)."
            : "Only the " +
            this.state.selectRemovePatient.length +
            " imported patient(s) will be removed. The MAXMRJ created patient(s) cannot removed.",
      });
      if (this.state.selectRemovePatient.length) {
        this.setState({
          confirmModalStatus: true,
        });
      } else {
        let showNotification = {
          title: "Remove Patients",
          message: "Only imported patiens can be remove",
          type: "warning",
        };
        userService.showNotification(showNotification);
      }
    } else {
      this.setState({ importModal: true });
    }
  };
  openPatientPopup() {
    const patientCategoryList = [];
    this.state.selectedPatientData.patientCatagoryMapping &&
      this.state.selectedPatientData.patientCatagoryMapping.map((el) => {
        return patientCategoryList.push(el.categoryId);
      });
    let isFaceSheetAdded =
      this.state.selectedPatientData.faceSheet &&
        this.state.selectedPatientData.faceSheet != ""
        ? true
        : false;
    let isImageAdded =
      this.state.selectedPatientData.photo &&
        this.state.selectedPatientData.photo != ""
        ? true
        : false;
    // let localDobLocal = this.dateUtility.format(
    //     new Date(this.state.selectedPatientData.patientDob),
    //     "MM/dd/yyyy"
    // );
    let estDate = this.state.selectedPatientData.eastimatedDischargeDate
      ? moment
        .utc(
          this.state.selectedPatientData.eastimatedDischargeDate,
          "YYYY-MM-DD"
        )
        .format("MM/DD/YYYY")
      : null;
    let actualEstDate = this.state.selectedPatientData.actualDischargeDate
      ? moment
        .utc(this.state.selectedPatientData.actualDischargeDate, "YYYY-MM-DD")
        .format("MM/DD/YYYY")
      : null;
    let dobDate = moment
      .utc(this.state.selectedPatientData.patientDob, "YYYY-MM-DD")
      .format("MM/DD/YYYY");
      const primaryDiagnosisValue =
    this.state.selectedPatientData.primaryDiagnosis || "";
  const reasonForSnfStayValue =
    this.state.selectedPatientData.snfStayReason || "";
    this.setState({
      firstName: this.state.selectedPatientData.firstName,
      lastName: this.state.selectedPatientData.lastName,
      primaryDiagnosis: primaryDiagnosisValue,
      reasonForSnfStay: reasonForSnfStayValue,
      middleName: this.state.selectedPatientData.middleName,
      insurance: this.state.selectedPatientData.insuranceId,
      hospital: this.state.selectedPatientData.previousHospitalId,
      gender: this.state.selectedPatientData.gender
        ? this.state.selectedPatientData.gender.toLowerCase()
        : "",
      dob: dobDate,
      benefitDaysRemaining: this.state.selectedPatientData.benefitDaysRemaining || "",
      estDate: estDate,
      actualEstDate: actualEstDate,
      patientCategories: patientCategoryList,
      modalStatus: true,
      patientImage: "",
      patientFaceSheet: "",
      patientImageName: "",
      patientFaceSheetName: "",
      isImage: false,
      isFaceSheet: false,
      isImageAdded: isImageAdded,
      isFaceSheetAdded: isFaceSheetAdded,
      patientImages: [],
      patientFaceSheets: [],
      patientImagesStr: [],
      patientFaceSheetsStr: [],
      patientUploadHistory: this.state.selectedPatientData.patientUploadHistory
        ? this.state.selectedPatientData.patientUploadHistory
        : [],
    });
    this.setState(
      {
        firstNameValid: true,
        lastNameValid: true,
        middleNameValid: true,
        genderValid: true,
        insuranceValid: true,
        hospitalValid: true,
        dobValid: true,

        estDateValid: true,
        actualEstDateValid: true,
        patientCategotiesValid: true,
          primaryDiagnosisValid: !!primaryDiagnosisValue.trim(),
          reasonForSnfStayValid: !!reasonForSnfStayValue.trim(),
      },
      this.validateForm
    );
  }
  showImportModal = () => {
    if (
      this.state.selectedPatientData &&
      this.state.selectedPatientId &&
      !this.state.multiPatientMode
    ) {
      this.setState({ importModal: true });
    } else {
      this.setState({ importModal: true });
    }
  };
  confirmModalClose() {
    this.setState({
      confirmModalMessage: "",
      confirmModalStatus: false,
    });
  }
  async confirmModalSubmit() {
    // this.setState({
    //     confirmModalMessage: "",
    //     confirmModalStatus: false,
    // })
    let showNotification = {};
    const {
      multiPatientMode,
      multiplePatientList,
      selectedPatientId,
      selectRemovePatient,
    } = this.state;
    let multiplePatientListArr = selectRemovePatient;
    if (multiplePatientListArr || multiplePatientListArr.length) {
      const data = {
        id: multiplePatientListArr,
      };
      this.setState({
        loading: true,
      });
      const response = await fetch(apiPath.unassignPatientToDash, {
        method: "POST",
        headers: generalAuthTokenHeader(),
        body: JSON.stringify(data),
      })
        .then((response) => {
          if (response.status === 400) {
            showNotification = {
              title: "Remove Patients",
              message: "Bad response from server",
              type: "danger",
            };
          } else if (response.ok) {
            showNotification = {
              title: "Remove Patients",
              message: "Patients removed from facility successfully",
              type: "success",
            };
            this.setState(
              {
                currentPage: 0,
                confirmModalMessage: "",
                confirmModalStatus: false,
                multiPatientMode: false,
                multiplePatientList: [],
                selectedPatientId: "",
                selectionCount: 0,
                selectRemovePatient: [],
              },
              () => this.fetchPatients()
            );
          } else {
            showNotification = {
              title: "Remove Patients",
              message: "Bad response from server. ",
              type: "danger",
            };
          }
          this.setState({ loading: false });
          return response.json();
        })
        .then((data) => {
          console.log(data);
          if (data.title) {
            showNotification = {
              title: "Remove Patients",
              message: data.title,
              type: "danger",
            };
          }
          userService.showNotification(showNotification);
        })
        .catch((error) => {
          console.log(error);
          showNotification = {
            title: "Remove Patients",
            message: "Something went wrong.Please try after sometime.." + error,
            type: "danger",
          };
          userService.showNotification(showNotification);
          this.setState({ loading: false });
        });
    } else {
      showNotification = {
        title: "Remove Patients",
        message: "Please select patients to remove",
        type: "warning",
      };
      userService.showNotification(showNotification);
    }
  }
  handleTNCAgree() {
    this.setState({
      openModal: false,
      termNcondition: false,
      bbaCondition: true,
    });
  }
  displayItems() {
    var items = [];
    for (var i = 0; i < this.state.items; i++) {
      items.push(<li key={i}>Item {i}</li>);
    }
    return items;
  }
  // loadMoreItems() {
  //   this.setState({ loadingState: true });
  //   setTimeout(() => {
  //     this.setState({ items: this.state.items + 10, loadingState: false });
  //   }, 3000);
  // }
  componentDidUpdate() {
    if (
      this.props.reduxLoadFlag != undefined &&
      this.state.reduxLoadFlag != this.props.reduxLoadFlag
    ) {
      let categoryList = [];
      let insuranceList = [];
      let hospitalList = [];
      let patientFilterList = [];
      let patientStatusList = [];
      let userInfo = {};
      if (this.props.categoryListRedux) {
        let selectedcategoryList = this.props.categoryListRedux;
        categoryList = selectedcategoryList ? selectedcategoryList : [];
      }
      if (this.props.insuranceListRedux) {
        let selectedinsuranceList = this.props.insuranceListRedux;
        insuranceList = selectedinsuranceList ? selectedinsuranceList : [];
      }
      if (this.props.hospitalListRedux) {
        let selectedhospitalList = this.props.hospitalListRedux;
        hospitalList = selectedhospitalList ? selectedhospitalList : [];
      }
      if (this.props.patientFilterListRedux) {
        let selectedpatientFilterList = this.props.patientFilterListRedux;
        patientFilterList = selectedpatientFilterList
          ? selectedpatientFilterList
          : [];
      }
      if (this.props.patientStatusListRedux) {
        let selectedpatientStatusList = this.props.patientStatusListRedux;
        patientStatusList = selectedpatientStatusList
          ? selectedpatientStatusList
          : [];
      }
      if (this.props.userInfoRedux) {
        let userInfoRedux = this.props.userInfoRedux;
        userInfo = userInfoRedux ? userInfoRedux : {};
      }
      this.setState({
        reduxLoadFlag: this.props.reduxLoadFlag,
        categoryList: categoryList,
        insuranceList: insuranceList,
        hospitalList: hospitalList,
        patientFilterList: patientFilterList,
        patientStatusList: patientStatusList,
        userInfo: userInfo,
      });
    }
    if ("onorientationchange" in window) {
      window.addEventListener(
        "orientationchange",
        function () {
          // `this` is now pointing to `window`, not the component. So use `self`.
          window.dispatchEvent(new Event("resize"));
          console.log("orientationchange change...");
        },
        false
      );
    }
  }
  componentWillUnmount() {
    Object.getPrototypeOf(this).constructor.STATE = this.state;
  }
  UNSAFE_componentWillMount() {
    // // this.setState(Object.getPrototypeOf(this).constructor.STATE || {});
    // if (Object.getPrototypeOf(this).constructor.STATE) {
    //     // let patientList = JSON.parse(sessionStorage.getItem(PATIENT_LIST));
    //     // let selectedPatientId = JSON.parse(localStorage.getItem(SELECTED_PATIENT_LIST));
    //     // localStorage.removeItem(SELECTED_PATIENT_LIST)
    //     // this.setState({ patientList: patientList })
    //     var stataData = Object.getPrototypeOf(this).constructor.STATE;
    //     // var loadPatient = false;
    //     // this.fetchPatientInfo(selectedPatientId);
    //     let totalStateLen = 0;
    //     Object.keys(stataData).map((v, i) => {
    //         //     loadPatient = stataData[v];
    //         console.log("pateintInfo", stataData[v], v, i)
    //         if (v == "filter" || v == "sorting") {
    //             totalStateLen++;
    //             this.setState({
    //                 [v]: stataData[v],
    //             }, () => this.callFetchPateintMethod(totalStateLen))
    //         }
    //         // if (v == "loadPatient")
    //         // if (v == "patientList" || v == "selectedPatientId" || v == "loading" || v == "selectedPatientData") {
    //         //     console.log(stataData[v], v, i)
    //         // } else {
    //         //     this.setState({
    //         //         [v]: stataData[v],
    //         //     })
    //         // }
    //     });
    // }
  }
  openRemoveFromDashboardConfirm = () => {
    if (!this.state.multiplePatientList.length) {
      return;
    }
    this.setState({ removeFromDashboardConfirmOpen: true });
  };

  closeRemoveFromDashboardConfirm = () => {
    this.setState({ removeFromDashboardConfirmOpen: false });
  };

  /**
   * Hides the ticked patients from the Dashboard by setting manual_dashboard_status = REMOVED.
   * They stay in MaxMRJ and remain visible in the All / New / Current / Discharged tabs, where
   * the toggle can put them back. This is NOT the Import modal's "Remove from MAX MRJ".
   */
  confirmRemoveFromDashboard = async () => {
    const patientIds = [...this.state.multiplePatientList];
    if (!patientIds.length) {
      this.setState({ removeFromDashboardConfirmOpen: false });
      return;
    }
    this.setState({ removingFromDashboard: true });
    try {
      const response = await fetch(apiPath.updateShowOnDashboardBulk, {
        method: "PUT",
        headers: generalAuthTokenHeader(),
        body: JSON.stringify({ patientIds: patientIds, show: false }),
      });
      if (response.status === 401) {
        userService.logout();
        window.location.replace(baseRoutes.login.path);
        return;
      }
      if (!response.ok) {
        throw new Error("bulk remove failed");
      }
      const updated = await response.json();
      userService.showNotification({
        title: "Dashboard",
        message:
          updated +
          " patient(s) removed from the Dashboard. Find them in the All Patients tab to add them back.",
        type: "success",
      });
      // Clear the selection and refetch from page 0 so the removed rows disappear.
      this.setState(
        {
          removeFromDashboardConfirmOpen: false,
          multiplePatientList: [],
          multiPatientMode: false,
          selectionCount: 0,
          selectedPatientId: "",
          selectedPatientData: {},
          currentPage: 0,
          patientList: [],
        },
        () => this.fetchPatients()
      );
    } catch (err) {
      userService.showNotification({
        title: "Dashboard",
        message: "Could not remove the selected patients. Please try again.",
        type: "danger",
      });
      this.setState({ removeFromDashboardConfirmOpen: false });
    } finally {
      this.setState({ removingFromDashboard: false });
    }
  };

  /**
   * Dashboard visibility, mirroring the backend rule in
   * CustomPatientRepositoryImpl.dashboardVisibility(): manual = ADDED, nothing else.
   *
   * The automatic arm (manual = AUTO AND auto = ELIGIBLE) is switched off on both sides —
   * PCC sends no estimated discharge date, so the nightly job that maintained
   * auto_dashboard_status could never raise anyone and is disabled. Whatever is left in that
   * column is stale, so this must NOT read it: doing so would show the switch ON for patients
   * the Dashboard no longer contains.
   */
  isShownOnDashboard = (patient) =>
    Number(patient.manualDashboardStatus || 0) === MANUAL_ADDED;

  /**
   * Flip one patient's Dashboard membership from the non-Dashboard tabs. Always writes an
   * explicit ADDED/REMOVED, which pins the patient either way and stops the nightly job from
   * undoing the DP's choice.
   */
  handleShowOnDashboardToggle = async (patient) => {
    const patientId = patient.patientId;
    const nextValue = !this.isShownOnDashboard(patient);

    this.setState((prev) => ({
      savingDashboardIds: prev.savingDashboardIds.concat(patientId),
    }));
    try {
      const url =
        apiPath.updateShowOnDashboard +
        "/" +
        patientId +
        "/show-on-dashboard?show=" +
        nextValue;
      const response = await fetch(url, {
        method: "PUT",
        headers: generalAuthTokenHeader(),
      });
      if (response.status === 401) {
        userService.logout();
        window.location.replace(baseRoutes.login.path);
        return;
      }
      if (!response.ok) {
        throw new Error("save failed");
      }
      if (this.state.activeTab === "DASHBOARD") {
        // On the Dashboard tab the toggle IS the membership rule, so a patient switched off
        // no longer belongs in the list. Refetch from page 0 so they disappear and the
        // "Showing n/n" count corrects itself — leaving the row behind would show a patient
        // on the Dashboard whose toggle says they are not on it.
        this.setState({ currentPage: 0, patientList: [] }, () => this.fetchPatients());
      } else {
        // Everywhere else, update the row in place: tab membership does not depend on the
        // dashboard columns, so the patient stays in this tab either way, and a refetch
        // would throw away the DP's scroll position.
        this.setState((prev) => ({
          patientList: prev.patientList.map((p) =>
            p.patientId === patientId
              ? {
                ...p,
                manualDashboardStatus: nextValue ? MANUAL_ADDED : MANUAL_REMOVED,
              }
              : p
          ),
        }));
      }
    } catch (err) {
      userService.showNotification({
        title: "Show on Dashboard",
        message: "Could not update this patient. Please try again.",
        type: "danger",
      });
    } finally {
      this.setState((prev) => ({
        savingDashboardIds: prev.savingDashboardIds.filter(
          (id) => id !== patientId
        ),
      }));
    }
  };

  /**
   * A "discharged in the last N days" pill was clicked (Discharged tab only).
   *
   * Mirrors what the filter/sort controls do: reset paging, clear the selection and the
   * right-hand panel, refetch. Clicking the active pill returns to All, so the filter can
   * always be switched off without hunting for the All pill.
   */
  handleDischargedWithinFilter = (days) => {
    const next = this.state.dischargedWithinDays === days ? 0 : days;
    this.setState(
      {
        dischargedWithinDays: next,
        currentPage: 0,
        patientList: [],
        selectedPatientId: "",
        selectedPatientData: {},
        selectRemovePatient: [],
        multiplePatientList: [],
        multiPatientMode: false,
        selectionCount: 0,
      },
      () => this.fetchPatients()
    );
  };

  /**
   * Every tab renders this same screen — only the membership rule differs, and that lives on
   * the backend behind ?tab=. So a tab change is just "reset paging and refetch": the list is
   * cleared first so the infinite scroller cannot append the new tab's page 0 onto the old
   * tab's rows, and so a patient toggled off the Dashboard in another tab is gone the moment
   * the DP returns to it.
   */
  handleTabChange = (event, newTab) => {
    if (newTab === this.state.activeTab) {
      return;
    }
    this.setState(
      {
        activeTab: newTab,
        currentPage: 0,
        patientList: [],
        // The pill row only exists on Discharged, so leaving the tab resets it to
        // the default rather than to All.
        dischargedWithinDays: DISCHARGED_WITHIN_DEFAULT,
        // Insurance Type is on every tab, but resets with the tab so a selection made on one
        // tab can never silently narrow the next one.
        insuranceTypeId: INSURANCE_TYPE_ALL,
        // Same reset the filter/sort change does. Selections are per-row and the rows are
        // about to be replaced, and the right-hand panel (Find Providers / Tasks) is driven by
        // the ticked rows — leaving a selection behind would point it at a patient no longer
        // in the list.
        selectedPatientId: "",
        selectedPatientData: {},
        selectRemovePatient: [],
        multiplePatientList: [],
        multiPatientMode: false,
        selectionCount: 0,
      },
      () => this.fetchPatients()
    );
  };

  callFetchPateintMethod(totalStateLen) {
    if (
      totalStateLen == 2 &&
      this.props.location &&
      this.props.location.state &&
      this.props.location.state.resetDashboard == false
    ) {
      this.fetchPatients();
    }
  }
  async fetchPatients() {
    // Every fetch gets a sequence number and only the newest one is allowed to write
    // to state. Switching tabs quickly fired a second request while the first was in
    // flight, and whichever RESPONSE landed last won — which is how All Patients rows
    // ended up rendered under the Dashboard tab. Typing in the search box makes this
    // far more likely, since it now fires a request per keystroke burst.
    const seq = ++this.fetchSeq;
    this.setState({
      loadingPatient: true,
    });
    let showNotification = {};
    let apiUrl = "";
    let searchKeyword = this.state.patientSearchKeyword;
    if (searchKeyword && searchKeyword.length > 0) {
      apiUrl =
        apiPath.getPatientList +
        "?page=" +
        this.state.currentPage +
        "&size=" +
        this.state.perPage +
        (this.state.filter && this.state.filter != ""
          ? "&filterBy=" + this.state.filter
          : "") +
        "&orderBy=" +
        (this.state.sorting && this.state.sorting != ""
          ? this.state.sorting
          : "10") +
        "&search=" +
        searchKeyword;
    } else {
      apiUrl =
        apiPath.getPatientList +
        "?page=" +
        this.state.currentPage +
        "&size=" +
        this.state.perPage +
        (this.state.filter && this.state.filter != ""
          ? "&filterBy=" + this.state.filter
          : "") +
        "&orderBy=" +
        (this.state.sorting && this.state.sorting != ""
          ? this.state.sorting
          : "10") +
        "";
    }
    // Org Admin: scope the patient list by the active facility. Read it from the per-tab
    // resolver (sessionStorage, captured from the URL at load) rather than the live URL, so
    // the scope survives in-tab navigation that drops the query string (e.g. the MAXMRJ Home
    // icon). The backend resolves the active facility from this param.
    const activeFid = getActiveFacilityId();
    if (activeFid) {
      apiUrl += "&facilityId=" + activeFid;
    }
    // The tab is the only difference between the five listings — same screen, same search,
    // filters and sorting, only the membership rule changes, and the backend owns that rule.
    // Sent for DASHBOARD too: it is the backend's default, so this is explicit rather than
    // implied. Both facility types send it; a hand-entry facility only ever sends
    // DASHBOARD or ALL, since those are the only two tabs it has.
    if (this.state.activeTab) {
      apiUrl += "&tab=" + this.state.activeTab;
    }
    // Discharged tab only. Guarded on the tab as well as the value so a stale
    // selection can never narrow another tab's list.
    if (
      this.state.activeTab === "DISCHARGED" &&
      this.state.dischargedWithinDays > 0
    ) {
      apiUrl += "&dischargedWithinDays=" + this.state.dischargedWithinDays;
    }
    // Insurance Type pill row, on every tab. 0 (All) is omitted entirely.
    if (this.state.insuranceTypeId > 0) {
      apiUrl += "&insuranceTypeId=" + this.state.insuranceTypeId;
    }
    const response = await fetch(apiUrl, {
      method: "GET",
      headers: generalAuthTokenHeader(),
    })
      .then((response) => {
        if (response.status === 400) {
          showNotification = {
            title: "Patient List",
            message: "Bad response from server",
            type: "danger",
          };
        } else if (response.ok) {
          let totalPatientCount = response.headers.get("X-Total-Count");
          if (seq === this.fetchSeq) {
            this.setState({
              total: totalPatientCount,
            });
          }
        } else if (response.status === 401) {
          userService.logout();
          //window.location.reload(true);
          window.location.replace(baseRoutes.login.path);
        } else {
          showNotification = {
            title: "Patient List",
            message: "Bad response from server",
            type: "danger",
          };
        }
        return response.json();
      })
      .then((data) => {
        // A superseded response must not touch the list, the paging cursor or the
        // loading flag — the newer request owns all of them now.
        if (seq !== this.fetchSeq) {
          return;
        }
        let localPatientList = this.state.patientList;
        if (this.state.currentPage == 0) {
          localPatientList = data;
        } else {
          localPatientList = localPatientList.concat(data);
        }
        let totalPatientShowing = localPatientList.length;
        let loadMore = false;
        let loadingState = false;
        let currentPage = this.state.currentPage;
        if (this.state.total > totalPatientShowing) {
          loadMore = true;
          loadingState = true;
          currentPage = currentPage + 1;
        }
        try {
          sessionStorage.setItem(PATIENT_LIST, JSON.stringify(localPatientList));
        } catch (e) {
          // sessionStorage quota exceeded — keep the previously stored list intact
          // so SinglePatientDetail and other components that read it don't break
          console.warn("sessionStorage quota exceeded, keeping previous patient list");
        }
        this.setState({
          patientList: localPatientList,
          totalPatientShowing: totalPatientShowing,
          loadMore: loadMore,
          currentPage: currentPage,
          loadingState: loadingState,
          loadingPatient: false,
        }, () => {
          // Invite-progress counts for the rows now on screen. Deliberately
          // AFTER the list renders rather than blocking it: the cards are
          // useful without the counts, and the button reads "INVITE" until
          // they land.
          this.fetchContactCounts(localPatientList);
          // Only now are the tab bar and the first row toggle actually on screen for the
          // tour to measure. Guarded internally so extra pages do not retrigger it.
          this.maybeStartDashboardTour();
        });
        userService.showNotification(showNotification);
        window.dispatchEvent(new Event("resize"));
      })
      .catch((error) => {
        showNotification = {
          title: "Patient List",
          message: "Bad response from server",
          type: "danger",
        };
        this.setState({
          loadingPatient: false,
        });
        userService.showNotification(showNotification);
      });
  }
  categorySelection = (patientId, patientInfo) => {
    this.fetchPatientInfo(patientId, patientInfo);
    console.log(patientId, patientInfo);
    var selectedPatientId = this.state.selectedPatientId;
    let selectedPatients = this.state.multiplePatientList;
    if (selectedPatients.includes(patientId)) {
      const index = selectedPatients.indexOf(patientId);
      if (index > -1) {
        selectedPatients.splice(index, 1);
      }
    } else {
      selectedPatients.push(patientId);
    }
    sessionStorage.setItem(MULTIPLE_PATIENT_LIST, JSON.stringify([patientId]));
    const {
      firstName,
      middleName,
      lastName,
      patientCatagoryMapping,
    } = patientInfo;
    const patientCategoryList = [];
    patientCatagoryMapping &&
      patientCatagoryMapping.map((el) => {
        return patientCategoryList.push(el.categoryId);
      });
    this.setState(
      {
        selectedPatientId: patientId,
        patientName:
          (lastName ? lastName : "") +
          ", " +
          firstName +
          " " +
          (middleName ? middleName : ""),
        patientCategoryList: patientCategoryList,
        selectionCount: 1,
        selectedPatientData: patientInfo,
        loading: false,
        patientTaskList: patientInfo.patientTask ? patientInfo.patientTask : [],
        multiplePatientList: [patientId],
        multiPatientMode: false,
        selectRemovePatient: patientInfo.thirdPartyPatientId
          ? [patientInfo.thirdPartyPatientId]
          : [],
      },
      () => this.modalOpen()
    );
  };
  modalOpen = () => {
    if (
      this.state.selectedPatientData &&
      this.state.selectedPatientId &&
      !this.state.multiPatientMode
    ) {
      const patientCategoryList = [];
      this.state.selectedPatientData.patientCatagoryMapping &&
        this.state.selectedPatientData.patientCatagoryMapping.map((el) => {
          return patientCategoryList.push(el.categoryId);
        });
      let isFaceSheetAdded =
        this.state.selectedPatientData.faceSheet &&
          this.state.selectedPatientData.faceSheet != ""
          ? true
          : false;
      let isImageAdded =
        this.state.selectedPatientData.photo &&
          this.state.selectedPatientData.photo != ""
          ? true
          : false;
      // let localDobLocal = this.dateUtility.format(
      //     new Date(this.state.selectedPatientData.patientDob),
      //     "MM/dd/yyyy"
      // );
      let estDate = this.state.selectedPatientData.eastimatedDischargeDate
        ? moment
          .utc(
            this.state.selectedPatientData.eastimatedDischargeDate,
            "YYYY-MM-DD"
          )
          .format("MM/DD/YYYY")
        : null;
      let actualEstDate = this.state.selectedPatientData.actualDischargeDate
        ? moment
          .utc(
            this.state.selectedPatientData.actualDischargeDate,
            "YYYY-MM-DD"
          )
          .format("MM/DD/YYYY")
        : null;
      let dobDate = moment
        .utc(this.state.selectedPatientData.patientDob, "YYYY-MM-DD")
        .format("MM/DD/YYYY");
         const primaryDiagnosisValue =
    this.state.selectedPatientData.primaryDiagnosis || "";
  const reasonForSnfStayValue =
    this.state.selectedPatientData.snfStayReason || "";
      this.setState({
        firstName: this.state.selectedPatientData.firstName,
        lastName: this.state.selectedPatientData.lastName,
        middleName: this.state.selectedPatientData.middleName,
        insurance: this.state.selectedPatientData.insuranceId,
        primaryDiagnosis: primaryDiagnosisValue,
      reasonForSnfStay: reasonForSnfStayValue,
        hospital: this.state.selectedPatientData.previousHospitalId,
        gender: this.state.selectedPatientData.gender
          ? this.state.selectedPatientData.gender.toLowerCase()
          : "",
        dob: dobDate,
        benefitDaysRemaining: this.state.selectedPatientData.benefitDaysRemaining || "",
        estDate: estDate,
        actualEstDate: actualEstDate,
        patientCategories: patientCategoryList,
        modalStatus: true,
        patientImage: "",
        patientFaceSheet: "",
        patientImageName: "",
        patientFaceSheetName: "",
        isImage: false,
        isFaceSheet: false,
        isImageAdded: isImageAdded,
        isFaceSheetAdded: isFaceSheetAdded,
        patientImages: [],
        patientFaceSheets: [],
        patientImagesStr: [],
        patientFaceSheetsStr: [],
        patientUploadHistory: this.state.selectedPatientData
          .patientUploadHistory
          ? this.state.selectedPatientData.patientUploadHistory
          : [],
      });
      this.setState(
        {
          firstNameValid: true,
          lastNameValid: true,
          middleNameValid: true,
          genderValid: true,
          insuranceValid: true,
          hospitalValid: true,
          dobValid: true,
          estDateValid: true,
          actualEstDateValid: true,
          patientCategotiesValid: true,
           primaryDiagnosisValid: !!primaryDiagnosisValue.trim(),
          reasonForSnfStayValid: !!reasonForSnfStayValue.trim(),
        },
        this.validateForm
      );
    } else {
      this.setState({
        firstName: "",
        lastName: "",
        middleName: "",
        insurance: "0",
        hospital: "",
        gender: "",
           primaryDiagnosis: "",
        reasonForSnfStay: "",
        dob: null,
        estDate: null,
        actualEstDate: null,
        patientCategories: [],
        modalStatus: true,
        patientImage: "",
        patientFaceSheet: "",
        patientImageName: "",
        patientFaceSheetName: "",
        isImage: false,
        isFaceSheet: false,
        isImageAdded: false,
        isFaceSheetAdded: false,
        patientImages: [],
        patientFaceSheets: [],
        patientImagesStr: [],
        patientFaceSheetsStr: [],
        patientUploadHistory: [],
        formErrors: {
          firstName: "",
          lastName: "",
          middleName: "",
          gender: "",
          insurance: "",
          hospital: "",
          dob: "",
          estDate: "",
          actualEstDate: "",
          patientCategoties: "",
          patientImage: "",
          patientFaceSheet: "",
             primaryDiagnosis: "",
        reasonForSnfStay: "",
        },
      });
      this.setState(
        {
          firstNameValid: false,
          lastNameValid: false,
          primaryDiagnosisValid: false,
          reasonForSnfStayValid: false,
          middleNameValid: true,
          genderValid: false,
          insuranceValid: true,
          hospitalValid: true,
          dobValid: false,
          estDateValid: true,
          actualEstDateValid: true,
          patientCategotiesValid: true,
        },
        this.validateForm
      );
    }
  };
  modalClose = () => {
    this.setState({
      modalStatus: false,
    });
  };
  handleChangeInput = (event) => {
    const name = event.target.name;
    let value = event.target.value;
    value = value.replace(/[^A-Za-z ]/gi, "");
    this.setState(
      {
        [name]: value,
      },
      () => {
        this.validateField(name, value);
      }
    );
  };


  async handleSubmit(event) {
    this.setState({
      loading: true,
      patientImagesStr: [],
      patientFaceSheetsStr: [],
    });
    event.preventDefault();
    this.middleHandleFn();
    return;
    let imageKeyCount = 0;
    if (this.state.patientFaceSheets && this.state.patientFaceSheets.length) {
      this.state.patientFaceSheets.map((file, key) => {
        if (typeof file !== undefined && file) {
          const fileReader = new FileReader();
          fileReader.addEventListener("load", () => {
            let result = fileReader.result;
            let patientFaceSheetsStr = this.state.patientFaceSheetsStr;
            let fileName = file.name;
            let filesObj = {};
            filesObj.base64Data = result;
            filesObj.uploadName = fileName;
            patientFaceSheetsStr.push(filesObj);
            if (imageKeyCount == key) {
              this.setState(
                {
                  patientFaceSheetsStr: patientFaceSheetsStr,
                },
                () => this.middleHandleFn()
              );
            } else {
              this.setState({
                patientFaceSheetsStr: patientFaceSheetsStr,
              });
            }
            imageKeyCount = imageKeyCount + 1;
          });
          if (file) {
            fileReader.readAsDataURL(file);
          }
        }
      });
    } else {
      this.setState(
        {
          patientFaceSheetsStr: [],
        },
        () => this.middleHandleFn()
      );
    }
    let imageArr = [];
    let facesheetKeyCount = 0;
    if (this.state.patientImages && this.state.patientImages.length) {
      this.state.patientImages.map((file) => {
        if (typeof file !== undefined && file) {
          const fileReader = new FileReader();
          fileReader.addEventListener("load", () => {
            let result = fileReader.result;
            let patientImagesStr = this.state.patientImagesStr;
            let fileName = file.name;
            let filesObj = {};
            filesObj.base64Data = result;
            filesObj.uploadName = fileName;
            patientImagesStr.push(filesObj);
            this.setState({
              patientImagesStr: patientImagesStr,
            });
            facesheetKeyCount = facesheetKeyCount + 1;
          });
          if (file) {
            fileReader.readAsDataURL(file);
          }
        }
      });
    }
    this.setState({
      // loading: false
    });
    let totalSec =
      (this.state.patientImages.length + this.state.patientFaceSheets.length) *
      100;
  }
  middleHandleFn() {
    if (this.state.selectedPatientId && this.state.selectedPatientData) {
      this.updatePatient(false);
    } else {
      this.createPatient();
    }
    return;
    if (
      this.state.patientFaceSheetsStr.length ==
      this.state.patientFaceSheets.length
    ) {
      if (this.state.selectedPatientId && this.state.selectedPatientData) {
        this.updatePatient(false);
      } else {
        this.createPatient();
      }
    }
  }
  async createPatient() {
    let showNotification = {};
    let localDobLocal = this.dateUtility.format(
      new Date(this.state.dob),
      "yyyy-MM-dd"
    );
    let estDateLocal = this.dateUtility.format(
      new Date(this.state.estDate),
      "yyyy-MM-dd"
    );
    let localDobMoment = this.state.dob
      ? this.dateUtility.format(new Date(this.state.dob), "yyyy-MM-dd")
      : null;
    let localEstMoment = this.state.estDate
      ? this.dateUtility.format(new Date(this.state.estDate), "yyyy-MM-dd")
      : null;
    let localActualEstMoment = this.state.actualEstDate
      ? this.dateUtility.format(
        new Date(this.state.actualEstDate),
        "yyyy-MM-dd"
      )
      : null;
    let faceSheet = this.state.isFaceSheet ? this.state.patientFaceSheet : null;
    let image = this.state.isImage ? this.state.patientImage : null;
    const data = {
      firstName: this.state.firstName ? this.state.firstName : "",
      lastName: this.state.lastName ? this.state.lastName : "",
      middleName: this.state.middleName ? this.state.middleName : "",
      insuranceId: this.state.insurance ? this.state.insurance : "",
      previousHospitalId: this.state.hospital ? this.state.hospital : "",
      gender: this.state.gender ? this.state.gender : "",
      dob: localDobMoment,
      estimatedDischargedate: localEstMoment,
      actualDischargeDate: localActualEstMoment,
      // actualDischargeDate: this.state.actualEstDate ? new Date(this.state.actualEstDate) : null,
      // primaryDiagnosis: this.state.primaryDiagnosis,
      // snfStayReason: this.state.reasonForSnfStay,
      patientStatusId: "7",
      categoryId: this.state.patientCategories.sort(function (a, b) {
        return a - b;
      }),
      createdById: this.state.userInfo.createdById,
    };
    // if (this.state.patientFaceSheetsStr && this.state.patientFaceSheetsStr.length) {
    //     data.faceSheet = this.state.patientFaceSheetsStr;
    // } else {
    //     data.faceSheet = null;
    // }
    // if (this.state.patientImagesStr && this.state.patientImagesStr.length) {
    //     data.photo = this.state.patientImagesStr;
    // } else {
    //     data.photo = null;
    // }
    showNotification = {
      title: "New Patient",
      message: "Create Patient, Please Wait",
      type: "info",
    };
    userService.showNotification(showNotification);
    showNotification = {};
    this.setState({
      loading: true,
    });
    // Pass the active facility so the backend stamps patient.facility_id for actors with no
    // DP row (Manager/Org-Admin). Without it the patient saves with a null facility and is
    // excluded from the facility-scoped list. Matches the &facilityId= the list call sends.
    const activeFid = getActiveFacilityId();
    const createUrl =
      apiPath.createPatient + (activeFid ? "?facilityId=" + activeFid : "");
    const response = await fetch(createUrl, {
      method: "POST",
      headers: generalAuthTokenHeader(),
      body: JSON.stringify(data),
      data: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status === 400) {
          showNotification = {
            title: "New Patient",
            message: "Bad response from server",
            type: "danger",
          };
        } else if (response.ok) {
        } else {
          showNotification = {
            title: "New Patient",
            message: "Bad response from server. " + response.status,
            type: "danger",
          };
        }
        userService.showNotification(showNotification);
        // this.modalClose();
        // this.setState({ loading: false });
        return response.json();
      })
      .then((data) => {
        if (data.patientId) {
          showNotification = {
            title: "Success",
            message: "Patient Successfully Created",
            type: "success",
          };
          userService.showNotification(showNotification);
          // this.modalClose();
          this.uploadImages(data.patientId, false);
          return true;
        } else {
          this.modalClose();
          this.setState({ loading: false });
          return true;
        }
      })
      .catch((error) => {
        showNotification = {
          title: "New Patient",
          message: "Something went wrong.Please try after sometime.." + error,
          type: "danger",
        };
        userService.showNotification(showNotification);
        this.setState({ loading: false });
        this.modalClose();
      });
  }
  async updatePatient() {
    let showNotification = {};
    this.setState({ isUpdating: true });
    let localDobLocal = this.state.dob
      ? this.formatDateToServerFormat(this.state.dob)
      : null;
    let estDateLocal = this.state.estDate
      ? this.formatDateToServerFormat(this.state.estDate)
      : null;
    let localDobMoment = this.state.dob
      ? this.dateUtility.format(new Date(this.state.dob), "yyyy-MM-dd")
      : null;
    let localEstMoment = this.state.estDate
      ? this.dateUtility.format(new Date(this.state.estDate), "yyyy-MM-dd")
      : null;
    let localActualEstMoment = this.state.actualEstDate
      ? this.dateUtility.format(
        new Date(this.state.actualEstDate),
        "yyyy-MM-dd"
      )
      : null;
    // let localActualEstMoment = this.state.actualEstDate ? localServerFormat(this.state.actualEstDate, 'UTC') : null;
    let faceSheet = this.state.isFaceSheet ? this.state.patientFaceSheet : null;
    let image = this.state.isImage ? this.state.patientImage : null;
    const data = {
      patientId: this.state.selectedPatientId,
      firstName: this.state.firstName,
      lastName: this.state.lastName,
      middleName: this.state.middleName,
      insuranceId: this.state.insurance,
      primaryDiagnosis: this.state.primaryDiagnosis,
      snfStayReason: this.state.reasonForSnfStay,
      previousHospitalId: this.state.hospital,
      gender: this.state.gender,
      dob: localDobMoment,
      estimatedDischargedate: localEstMoment,
      // actualDischargeDate: this.state.actualEstDate ? new Date(this.state.actualEstDate) : null,
      actualDischargeDate: localActualEstMoment,
      patientStatusId:
        this.state.selectedPatientData &&
          this.state.selectedPatientData.patientStatusId
          ? this.state.selectedPatientData.patientStatusId
          : "1",
      // categoryId: this.state.patientCategories,
      categoryId: this.state.patientCategories.sort(function (a, b) {
        return a - b;
      }),
      benefitDaysRemaining: this.state.benefitDaysRemaining ? parseInt(this.state.benefitDaysRemaining, 10) : null,
      createdById: this.state.userInfo.createdById,
    };
    // console.log(this.state.actualEstDate, localActualEstMoment, data)
    // return false
    // if (this.state.patientFaceSheetsStr && this.state.patientFaceSheetsStr.length) {
    //     data.faceSheet = this.state.patientFaceSheetsStr;
    // }
    // if (this.state.patientImagesStr && this.state.patientImagesStr.length) {
    //     data.photo = this.state.patientImagesStr;
    // }
    showNotification = {
      title: "Update Patient",
      message: "Updating Patient, Please Wait",
      type: "info",
    };
    userService.showNotification(showNotification);
    showNotification = {};
    this.setState({
      loading: true,
      isUpdating: true,
    });
    // return
    const response = await fetch(apiPath.createPatient, {
      method: "PUT",
      headers: generalAuthTokenHeader(),
      body: JSON.stringify(data),
      data: JSON.stringify(data),
    })
      .then((response) => {
        if (response.status === 400) {
          showNotification = {
            title: enMsg.updatePatientFailedTitle,
            message: "Bad response from server",
            type: "danger",
          };
        } else if (response.ok) {
        } else {
          showNotification = {
            title: enMsg.updatePatientFailedTitle,
            message: enMsg.updatePatientFailedDesc,
            type: "danger",
          };
          let error = new Error(response.statusText);
        }
        // this.setState({ loading: false });
        return response.json();
      })
      .then((data) => {
        if (data.status == 400) {
          showNotification = {
            title: enMsg.updatePatientFailedTitle,
            message: data.title,
            type: "danger",
          };
          userService.showNotification(showNotification);
        }
        if (data[0] && data[0].patientId) {
          let finalData = data[0];
          showNotification = {
            title: "Success",
            message: "Patient updated",
            type: "success",
          };
          let patientList = [];
          patientList = this.state.patientList.map((pList, key) => {
            if (pList.patientId == data[0].patientId) {
              pList = data[0];
            }
            return pList;
          });
          const patientCategoryList = [];
          finalData.patientCatagoryMapping &&
            finalData.patientCatagoryMapping.length &&
            finalData.patientCatagoryMapping.map((el) => {
              return patientCategoryList.push(el.categoryId);
            });
          sessionStorage.setItem(PATIENT_LIST, JSON.stringify(patientList));

          // this.modalClose();
          this.setState({
            // loading: false,
            patientName:
              (finalData.lastName ? finalData.lastName : "") +
              ", " +
              finalData.firstName +
              " " +
              (finalData.middleName ? finalData.middleName : ""),
            selectedPatientData: data[0],
            patientCategoryList: patientCategoryList,
            patientList: patientList,
            isUpdating: false,
          });
          window.dispatchEvent(new Event("resize"));
          userService.showNotification(showNotification);
          this.uploadImages(this.state.selectedPatientId, true);

          return true;
        } else {
          this.modalClose();
          this.setState({ loading: false });
          return true;
        }
      })
      .catch((error) => {
        showNotification = {
          title: enMsg.updatePatientFailedTitle,
          message: enMsg.updatePatientFailedDesc,
          type: "danger",
        };
        userService.showNotification(showNotification);
        this.setState({ loading: false });
      });
  }
  async uploadImages(patientId, patienFlag) {
    let showNotification = {};
    if (this.state.patientFaceSheets && !this.state.patientFaceSheets.length) {
      this.modalClose();
      this.setState(
        {
          loading: false,
        },
        () => this.fetchPatients()
      );
      return true;
    } else {
      showNotification = {
        title: "Uploading Files",
        message: "Uploading Files, Please Wait",
        type: "info",
      };
      userService.showNotification(showNotification);
      showNotification = {};
    }
    const data = {
      files: this.state.patientFaceSheets.length
        ? this.state.patientFaceSheets
        : [],
    };
    this.setState({
      loading: true,
    });
    const datas = new FormData();
    this.state.patientFaceSheets.map((files, key) => {
      datas.append("files", files);
    });
    const response = await fetch(
      apiPath.uploadPatientFiles1 + "/" + patientId,
      {
        method: "POST",
        headers: generalMimeAuthTokenHeader(),
        body: datas,
        data: datas,
      }
    )
      .then((response) => {
        if (response.status === 400) {
          showNotification = {
            title: "Patient Files",
            message: "Patient Files Not Uploaded, Please try again",
            type: "danger",
          };
        } else if (response.ok) {
          showNotification = {
            title: "Patient Files",
            message: "Patient Files Uploaded",
            type: "success",
          };
          return response.text();
        } else {
          showNotification = {
            title: "Patient Files",
            message: "Patient Files Not Uploaded, Please try again",
            type: "danger",
          };
        }
        this.modalClose();
        this.setState({ loading: false });
        return response.json();
      })
      .then((data) => {
        this.modalClose();
        this.setState({ loading: false });
        userService.showNotification(showNotification);
        if (patienFlag) {
          this.fetchPatientInfo();
        } else {
          this.setState(
            {
              // loading: false,
              currentPage: 0,
              patientSearchKeyword: "",
              sorting: "2",
              filter: "",
            },
            () => this.fetchPatients()
          );
        }
        return true;
      })
      .catch((error) => {
        showNotification = {
          title: "Patient Files",
          message: "Patient Files Not Uploaded, Please try again",
          type: "danger",
        };
        userService.showNotification(showNotification);
        this.setState({ loading: false });
        this.modalClose();
      });
  }
  /* Same download the patient detail screen's removed "Download Documents" button did,
     moved next to the list of documents it acts on. Mirrors PatientForm.jsx, which is the
     other Edit Patient dialog. */
  downloadUploadedDocuments = async () => {
    const files = this.state.patientUploadHistory;
    if (!files || !files.length) {
      userService.showNotification({
        title: "Documents",
        message: "No documents available.",
        type: "danger",
      });
      return;
    }
    this.setState({ downloadingDocs: true });
    userService.showNotification({
      title: "Documents",
      message:
        "Downloading " +
        files.length +
        " file(s). This process might take a long time, please be patient.",
      type: "infoLong",
    });
    try {
      let zip = new JSZip();
      let added = 0;
      for (let i = 0; i < files.length; i++) {
        let urlArr = (files[i].uploadUrl || "").split("/");
        let fileKey = urlArr[urlArr.length - 2] + "/" + urlArr[urlArr.length - 1];
        let blob = await userService.fetchFilesBlob(
          apiPath.downloadCommentFile + "?key=" + fileKey,
          files[i].uploadName
        );
        // One bad file should not cost the DP the rest of the set.
        if (blob) {
          zip.file(i + "_" + files[i].uploadName, blob);
          added = added + 1;
        }
      }
      if (!added) {
        userService.showNotification({
          title: "Documents",
          message: "Could not download the documents, please try again.",
          type: "danger",
        });
        return;
      }
      let content = await zip.generateAsync({ type: "blob" });
      saveAs(content, "pateintFiles_" + Date.now() + ".zip");
    } finally {
      this.setState({ downloadingDocs: false });
    }
  };

  async deleteImages(facesheetId) {
    let showNotification = {};
    this.setState({
      loading: true,
    });
    const response = await fetch(
      apiPath.deleteFaceSheeet + "?facesheetId=" + facesheetId,
      {
        method: "DELETE",
        headers: generalAuthTokenHeader(),
      }
    )
      .then((response) => {
        console.log(response);
        if (response.status === 400) {
          showNotification = {
            title: "Delete File",
            message: "Bad response from server",
            type: "danger",
          };
          this.setState({
            loading: false,
          });
        } else if (response.ok) {
          showNotification = {
            title: "Success",
            message: "File Successfully Deleted",
            type: "success",
          };
          let faceArr = [];
          faceArr = this.state.patientUploadHistory.filter((v, i) => {
            return v.id != facesheetId;
          });
          this.setState({
            patientUploadHistory: faceArr,
          });
          return response.text();
        } else {
          showNotification = {
            title: "Delete File",
            message: "Bad response from server",
            type: "danger",
          };
          this.setState({
            loading: false,
          });
        }
        return response.json();
      })
      .then((data) => {
        this.setState({
          loading: false,
        });
        userService.showNotification(showNotification);
      })
      .catch((error) => {
        showNotification = {
          title: "Delete File",
          message: "Something went wrong.Please try after sometime..",
          type: "danger",
        };
        userService.showNotification(showNotification);
        this.setState({ loading: false });
        this.modalClose();
      });
  }
  validateField = (fieldName, fieldValue) => {
    let fieldValidationErrors = this.state.formErrors;
    let facilityNameValid = this.state.facilityNameValid;
    let addressValid = this.state.addressValid;
    let primaryPhoneValid = this.state.primaryPhoneValid;
    let statusValid = this.state.statusValid;
    let secondaryPhoneValid = this.state.secondaryPhoneValid;

    let firstNameValid = this.state.firstNameValid;
    let lastNameValid = this.state.lastNameValid;
    let middleNameValid = this.state.middleNameValid;
    let genderValid = this.state.genderValid;
    let insuranceValid = this.state.insuranceValid;
    let hospitalValid = this.state.hospitalValid;
    let dobValid = this.state.dobValid;
    let estDateValid = this.state.estDateValid;
    let actualEstDateValid = this.state.actualEstDateValid;
    let patientCategotiesValid = this.state.patientCategotiesValid;
 let primaryDiagnosisValid = this.state.primaryDiagnosisValid;
    let reasonForSnfStayValid = this.state.reasonForSnfStayValid;
    let benefitDaysRemainingValid = this.state.benefitDaysRemainingValid;
    switch (fieldName) {
      case "firstName":
        firstNameValid = fieldValue.trim().length > 0;
        fieldValidationErrors.firstName = firstNameValid
          ? ""
          : enMsg.firstNameRequiredMsg;
        break;
      case "middleName":
        middleNameValid =
          (fieldValue && fieldValue.trim().length > 0) || fieldValue == ""
            ? true
            : false;
        fieldValidationErrors.middleName = middleNameValid
          ? ""
          : enMsg.middleNameRequiredMsg;
        break;
      case "lastName":
        lastNameValid = fieldValue.trim().length > 0;
        fieldValidationErrors.lastName = lastNameValid
          ? ""
          : enMsg.lastNameRequiredMsg;
        break;
      case "gender":
        genderValid = fieldValue && fieldValue.trim().length > 0 ? true : false;
        fieldValidationErrors.gender = !genderValid
          ? enMsg.genderRequiredMsg
          : "";
        break;
      case "insurance":
        insuranceValid = fieldValue || fieldValue == "" ? true : false;
        fieldValidationErrors.insurance = !insuranceValid
          ? enMsg.insuranceRequiredMsg
          : "";
        break;
      case "hospital":
        hospitalValid = fieldValue || fieldValue == "" ? true : false;
        fieldValidationErrors.hospital = !hospitalValid
          ? enMsg.hospitalRequiredMsg
          : "";
        break;
          case "primaryDiagnosis":
        if (fieldValue.trim().length === 0) {
          primaryDiagnosisValid = false;
          fieldValidationErrors.primaryDiagnosis = "Primary Diagnosis is required.";
        } else if (fieldValue.length >= 1000) {
          primaryDiagnosisValid = false;
          fieldValidationErrors.primaryDiagnosis = "Character limit of 1000 reached.";
        } else {
          primaryDiagnosisValid = true;
          fieldValidationErrors.primaryDiagnosis = "";
        }
        break;
 
      case "reasonForSnfStay":
        if (fieldValue.trim().length === 0) {
          reasonForSnfStayValid = false;
          fieldValidationErrors.reasonForSnfStay = "Reason for SNF Stay is required.";
        } else if (fieldValue.length >= 1000) {
          reasonForSnfStayValid = false;
          fieldValidationErrors.reasonForSnfStay = "Character limit of 1000 reached.";
        } else {
          reasonForSnfStayValid = true;
          fieldValidationErrors.reasonForSnfStay = "";
        }
        break;
      case "dob":
        dobValid = fieldValue && fieldValue != "" ? true : false;
        fieldValidationErrors.dob = !dobValid ? enMsg.dobRequiredMsg : "";
        break;
      // case "estDate":
      //     estDateValid = (fieldValue && fieldValue != "") ? true : false;
      //     fieldValidationErrors.estDate = !estDateValid
      //         ? enMsg.estDateRequiredMsg
      //         : "";
      //     break;
      case "patientCategoties":
        patientCategotiesValid =
          fieldValue || fieldValue.length == 0 ? true : false;
        fieldValidationErrors.patientCategoties = !patientCategotiesValid
          ? enMsg.categoryRequiredMsg
          : "";
        break;
      case "address":
        addressValid = fieldValue.trim().length > 0;
        fieldValidationErrors.address = addressValid
          ? ""
          : enMsg.addressRequiredErrorMsg;
        break;
      case "status":
        statusValid = fieldValue ? true : false;
        fieldValidationErrors.status = statusValid ? "" : "Status is required";
        break;
      case "benefitDaysRemaining":
        benefitDaysRemainingValid = true;
        if (fieldValue && fieldValue !== "") {
          const numValue = parseInt(fieldValue, 10);
          if (isNaN(numValue) || numValue < 1) {
            benefitDaysRemainingValid = false;
            fieldValidationErrors.benefitDaysRemaining = "Benefit Days must be at least 1";
          } else {
            fieldValidationErrors.benefitDaysRemaining = "";
          }
        } else {
          fieldValidationErrors.benefitDaysRemaining = "";
        }
        break;
      default:
        break;
    }
    this.setState(
      {
        formErrors: fieldValidationErrors,
        firstNameValid: firstNameValid,
        lastNameValid: lastNameValid,
        middleNameValid: middleNameValid,
        genderValid: genderValid,
        insuranceValid: insuranceValid,
        hospitalValid: hospitalValid,
        dobValid: dobValid,
        estDateValid: estDateValid,
        actualEstDateValid: actualEstDateValid,
        patientCategotiesValid: patientCategotiesValid,
         primaryDiagnosisValid,
        reasonForSnfStayValid,
        benefitDaysRemainingValid,
      },
      this.validateForm
    );
  };
  validateForm() {
  const baseValid =
      this.state.firstNameValid &&
      this.state.lastNameValid &&
      this.state.middleNameValid &&
      this.state.genderValid &&
      this.state.insuranceValid &&
      this.state.hospitalValid &&
      this.state.dobValid &&
      this.state.estDateValid &&
      this.state.actualEstDateValid &&
    this.state.patientCategotiesValid;

  // ✅ If updating, also require these
  if (this.state.selectedPatientId) {
    return (
      baseValid &&
      this.state.primaryDiagnosisValid &&
      this.state.reasonForSnfStayValid
    );
  }

  // ✅ If creating, only check base fields
  return baseValid;
}

  search(event) {
    event.preventDefault();
    if (event.target.keyCode === 13) {
      return;
    }
    let searchKeyword = event.target.value.trim();
    let dpDashboardFilter = JSON.parse(
      localStorage.getItem(DP_DASHBOARD_FILTERS)
    );
    dpDashboardFilter = dpDashboardFilter ? dpDashboardFilter : {};
    dpDashboardFilter.patientSearchKeyword = searchKeyword;
    localStorage.setItem(
      DP_DASHBOARD_FILTERS,
      JSON.stringify(dpDashboardFilter)
    );
    this.setState({
      patientSearchKeyword: searchKeyword,
      currentPage: 0,
      patientList: [],
      selectedPatientId: "",
      selectRemovePatient: [],
      patientName: "",
      patientCategoryList: [],
      multiPatientMode: false,
      multiplePatientList: [],
      selectionCount: 0,
    });

    // Search as you type. Debounced so a word is one request rather than one per
    // keystroke; the fetchSeq guard in fetchPatients discards any that are overtaken.
    // Enter still works — searchReturn fires immediately — it is just no longer required.
    if (this.searchDebounce) {
      clearTimeout(this.searchDebounce);
    }
    this.searchDebounce = setTimeout(() => this.fetchPatients(), 400);
    return true;
  }
  searchReturn(event) {
    if (event.target.keyCode === 13 || event.key === "Enter") {
      event.preventDefault();
      if (this.searchDebounce) {
        clearTimeout(this.searchDebounce);
      }
      this.fetchPatients();
    }
  }

  /**
   * Clear the search box and refetch unfiltered.
   *
   * Mirrors what search() writes, then fetches — search() only updates state and leaves the
   * fetch to Enter, but this button has to do both. The localStorage write matters: the
   * keyword is restored on mount from DP_DASHBOARD_FILTERS, so clearing state alone would
   * bring the old term back on the next reload.
   */
  clearSearch = () => {
    let dpDashboardFilter = JSON.parse(
      localStorage.getItem(DP_DASHBOARD_FILTERS)
    );
    dpDashboardFilter = dpDashboardFilter ? dpDashboardFilter : {};
    dpDashboardFilter.patientSearchKeyword = "";
    localStorage.setItem(
      DP_DASHBOARD_FILTERS,
      JSON.stringify(dpDashboardFilter)
    );
    this.setState(
      {
        patientSearchKeyword: "",
        currentPage: 0,
        patientList: [],
        selectedPatientId: "",
        selectedPatientData: {},
        selectRemovePatient: [],
        patientName: "",
        patientCategoryList: [],
        multiPatientMode: false,
        multiplePatientList: [],
        selectionCount: 0,
      },
      () => this.fetchPatients()
    );
  };
  handlePatientSorting = (event) => {
    let dpDashboardFilter = JSON.parse(
      localStorage.getItem(DP_DASHBOARD_FILTERS)
    );
    dpDashboardFilter = dpDashboardFilter ? dpDashboardFilter : {};
    const name = event.target.name;
    const sortByValue = event.target.value;
    dpDashboardFilter[name] = sortByValue;
    localStorage.setItem(
      DP_DASHBOARD_FILTERS,
      JSON.stringify(dpDashboardFilter)
    );
    this.setState(
      {
        [name]: sortByValue,
        currentPage: 0,
        selectedPatientId: "",
        selectRemovePatient: [],
        selectedPatientData: {},
        selectionCount: 0,
        multiPatientMode: false,
        multiplePatientList: [],
      },
      () => this.fetchPatients()
    );
  };

  /**
   * Click on a patient card (name / DOB / status / insurance / location block).
   *
   * First click selects — the right-hand Find Providers and Tasks panels fill in.
   * A second click on the patient that's already open goes to Patient Detail. It used
   * to deselect, which the client called unintuitive: deselecting is now only the
   * checkbox's job, or a side effect of selecting a different patient.
   *
   * The decision lives here rather than in fetchPatientInfo because that method has
   * four other callers (categorySelection, fetchPatientList, updatePatient, and the
   * no-arg refresh) that still want its plain toggle behaviour.
   */
  handlePatientCardClick = (patientId, patientInfo) => {
    if (patientId && patientId == this.state.selectedPatientId) {
      this.openPatientDetail(patientId);
      return;
    }
    this.fetchPatientInfo(patientId, patientInfo);
  };

  /**
   * Open Patient Detail for a patient that is already selected.
   *
   * SinglePatientDetail works out who to show from localStorage SELECTED_PATIENT_LIST —
   * it never reads a route param for the patient — and PatientDashboard clears that key
   * on mount, so it has to be written before the push. Same thing
   * CategoriesList.selectedPatient() does for the right-hand category links.
   *
   * `mode` is not optional: the detail page runs atob(atob(...)) on it and throws if the
   * param is missing. The patient was fetched by the first click, so the sessionStorage
   * PATIENT_LIST / patientInfo that page reads on mount are already populated.
   */
  openPatientDetail = (patientId) => {
    localStorage.setItem(SELECTED_PATIENT_LIST, JSON.stringify(patientId));
    this.props.history.push(
      `${basePath}${dpBaseRoutes.singlePatientInfo.path}?mode=${btoa(
        btoa(this.state.multiPatientMode)
      )}&facility=${btoa(btoa(this.state.facilityType))}`
    );
  };

  /**
   * MaxAlly invite, opened from the INVITE button on a patient row.
   *
   * ContactDialog is the whole invite flow and is reused as-is from Patient Detail — it
   * does not fetch its own contacts, so the list is loaded here first and handed down.
   * stopPropagation is the caller's job: the card is wrapped in handlePatientCardClick.
   */
  /**
   * Onboarding tour for the redesigned dashboard, shown once per user.
   *
   * Three gates, all of which must pass:
   *   1. the facility record has loaded, so the tab bar step 2 points at exists (a
   *      hand-entry facility has a two-tab bar, a PCC facility all five);
   *   2. the patient list has finished loading and has at least one row, so the toggle in
   *      step 3 exists to be highlighted;
   *   3. the backend says this user has not seen it.
   *
   * The "seen" flag lives on jhi_user, not localStorage, so it follows the planner across
   * browsers and machines.
   */
  maybeStartDashboardTour = async () => {
    if (this.tourChecked) {
      return;
    }
    // Runs for both facility types now that both have a tab bar. A hand-entry facility sees
    // a two-tab bar rather than five, which step 2 still points at correctly.
    if (!this.state.facilityType) {
      return;
    }
    if (this.state.loadingPatient || !this.state.patientList || !this.state.patientList.length) {
      return;
    }
    // Only attempt once per mount, whatever the answer.
    this.tourChecked = true;
    try {
      const response = await fetch(apiPath.dashboardTourStatus, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });
      if (!response.ok) {
        return;
      }
      const data = await response.json();
      if (data && data.seen === false) {
        this.setState({ tourSteps: this.buildTourSteps() });
      }
    } catch (e) {
      // A tour is not worth a visible error. Staying silent means the worst case is that
      // the planner simply does not see it.
      console.error("dashboard tour status failed", e);
    }
  };

  /**
   * Steps are built at open time so the targets are measured against the DOM as it is
   * now. Any step whose target has gone misses out rather than highlighting nothing.
   */
  buildTourSteps = () => {
    const steps = [
      {
        title: "Welcome to your new Dashboard",
        body: (
          <p>
            The Patient Directory has a new look. Here is a quick tour of what has
            changed - it takes about 20 seconds.
          </p>
        ),
      },
      {
        selector: ".pd-tabs",
        padding: 6,
        title: "Find patients faster with tabs",
        body: (
          <dl>
            <dt>Dashboard</dt>
            <dd>Patients you have chosen to track.</dd>
            <dt>All Patients</dt>
            <dd>Every patient at your facility.</dd>
            <dt>New</dt>
            <dd>Recently Added Patients.</dd>
            <dt>Current</dt>
            <dd>Admitted and not yet discharged.</dd>
            <dt>Discharged</dt>
            <dd>Patients who have been discharged.</dd>
          </dl>
        ),
      },
      {
        selector: "[data-tour='dashboard-toggle']",
        padding: 10,
        title: "Add a patient to your Dashboard",
        body: (
          <p>
            Use this toggle on any patient to add them to your Dashboard, or remove them
            again. Your Dashboard is yours - only the patients you pick appear there.
          </p>
        ),
      },
    ];
    return steps.filter((step) => !step.selector || document.querySelector(step.selector));
  };

  /**
   * Closes the tour and records it server-side. Finishing and skipping are recorded the
   * same way: the planner has been shown it, and the decision chosen was not to replay.
   */
  handleTourClose = (skipped) => {
    this.setState({ tourSteps: null });
    fetch(apiPath.dashboardTourSeen, {
      method: "PUT",
      headers: generalAuthTokenHeader(),
    }).catch((e) => console.error("dashboard tour mark-seen failed", e));
  };

  handleOpenInviteDialog = async (pList) => {
    const { firstName, middleName, lastName } = pList;
    this.setState({
      contactPatient: {
        patientId: pList.patientId,
        patientName:
          (lastName ? lastName : "") + ", " + firstName + " " + (middleName ? middleName : ""),
        estimatedDischargeDate: pList.eastimatedDischargeDate || null,
      },
      contactList: [],
    });
    await this.fetchContactList(pList.patientId);
    this.setState({ openContactDialog: true });
  };

  closeInviteDialog = () => {
    this.setState({ openContactDialog: false, contactPatient: null, contactList: [] });
  };

  /**
   * Discharge planner id for the contact API. Org Admins have no dischargeplanner row, so
   * they fall back to their own user id — same derivation SinglePatientDetail uses.
   */
  getDischargePlannerId = () => {
    const userInfo =
      this.state.userInfo && Object.keys(this.state.userInfo).length
        ? this.state.userInfo
        : JSON.parse(localStorage.getItem(USER_INFO)) || {};
    return (userInfo.dischargePlanner && userInfo.dischargePlanner.id) || userInfo.createdById || null;
  };

  /**
   * Ported from SinglePatientDetail, with the patient id as a parameter — that version
   * reads it from localStorage SELECTED_PATIENT_LIST, which is meaningless on a list page
   * where every row is a different patient.
   */
  /**
   * Invite-progress counts for a page of patient cards, in one request.
   *
   * Asking per card would be one request per row — 20+ on a full page, and
   * again on every "load more". The endpoint takes the whole id list instead.
   *
   * Counts are merged rather than replaced, so paging in more patients keeps
   * the counts already held for the rows above. Failures are swallowed on
   * purpose: the label falls back to plain "INVITE", which is still correct
   * and still works, so a red toast about a decoration would be noise.
   */
  fetchContactCounts = async patientList => {
    const ids = (Array.isArray(patientList) ? patientList : [])
      .map(p => p && p.patientId)
      .filter(id => id != null);
    if (!ids.length) return;

    // Guarded by the same sequence number as the list itself, so a superseded
    // page's counts cannot land on top of the current page's.
    const seq = this.fetchSeq;

    try {
      const response = await fetch(
        apiPath.GetPatientContactCounts + "?patientIds=" + ids.join(","),
        { method: "GET", headers: generalAuthTokenHeader() }
      );
      if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
        return;
      }
      if (!response.ok) return;

      const data = await response.json();
      if (seq !== this.fetchSeq) return;

      this.setState(prev => ({
        contactCounts: Object.assign(
          {},
          prev.contactCounts,
          indexCountsByPatient(data)
        )
      }));
    } catch (error) {
      console.warn("Could not load MaxAlly invite counts", error);
    }
  };

  fetchContactList = async (patientId) => {
    const id = patientId || (this.state.contactPatient && this.state.contactPatient.patientId);
    if (!id) {
      return;
    }
    const apiUrl =
      apiPath.GetAllPatientContactList +
      "?patientId=" + id +
      "&dpId=" + this.getDischargePlannerId();
    try {
      const response = await fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      });
      if (response.status === 401) {
        userService.logout();
        window.location.reload(true);
        return;
      }
      if (!response.ok) {
        userService.showNotification({
          title: "Contact List",
          message: "Error fetching contacts",
          type: "danger",
        });
        return;
      }
      const data = await response.json();
      const contacts = Array.isArray(data) ? data : [];
      // Re-derive this patient's counts from the list we just fetched, so the
      // card's label updates the moment an invite is sent rather than waiting
      // for the next page load. Same rules as the server's count — see
      // countsFromContactList.
      this.setState(prev => ({
        contactList: contacts,
        contactCounts: Object.assign({}, prev.contactCounts, {
          [id]: countsFromContactList(id, contacts)
        })
      }));
    } catch (error) {
      console.error("Error fetching contact list", error);
      userService.showNotification({
        title: "Contact List",
        message: "Server Error",
        type: "danger",
      });
    }
  };

  /**
   * Partial update used by ContactDialog's "apply default template" popup so the DP can
   * confirm the estimated discharge date at invite time. Ported from SinglePatientDetail;
   * here it also patches the row in place so the list reflects the new date without a refetch.
   */
  handleUpdateEstimatedDischargeDate = async (newIsoDate) => {
    const patientId = this.state.contactPatient && this.state.contactPatient.patientId;
    if (!newIsoDate || !patientId) {
      return Promise.reject(new Error("Missing patient id or date"));
    }
    const url =
      `${apiPath.updateEstimatedDischargeDate}/${patientId}` +
      `/estimated-discharge-date?date=${encodeURIComponent(newIsoDate)}`;
    const response = await fetch(url, {
      method: "PUT",
      headers: generalAuthTokenHeader(),
    });
    if (response.status === 401) {
      userService.logout();
      window.location.reload(true);
      return Promise.reject(new Error("401"));
    }
    if (!response.ok) {
      throw new Error(`updateEstimatedDischargeDate failed with status ${response.status}`);
    }
    const updatedPatient = await response.json();
    this.setState((prev) => ({
      contactPatient: prev.contactPatient
        ? { ...prev.contactPatient, estimatedDischargeDate: newIsoDate }
        : prev.contactPatient,
      patientList: (prev.patientList || []).map((p) =>
        p && p.patientId === updatedPatient.patientId
          ? { ...p, eastimatedDischargeDate: newIsoDate }
          : p
      ),
    }));
    try {
      const cached = JSON.parse(sessionStorage.getItem(PATIENT_LIST));
      if (Array.isArray(cached)) {
        sessionStorage.setItem(
          PATIENT_LIST,
          JSON.stringify(
            cached.map((p) =>
              p && p.patientId === updatedPatient.patientId
                ? { ...p, eastimatedDischargeDate: newIsoDate }
                : p
            )
          )
        );
      }
    } catch (e) {
      // cache refresh is best-effort; the PUT already succeeded
    }
    return newIsoDate;
  };

  /**
   * @param seq selection token from fetchPatientList, when this was triggered by a
   *            checkbox. Undefined for the other callers (row click, post-save refresh),
   *            which are not racing a selection and always apply.
   */
  fetchPatientInfo = (patientId, patientInfo, seq) => {

    try {
      if (patientId == this.state.selectedPatientId) {
        this.setState({
          selectedPatientId: "",
          selectedPatientData: {},
          selectionCount: 0,
          multiPatientMode: false,
          multiplePatientList: [],
          selectRemovePatient: [],
        });
        return;
      }
      sessionStorage.setItem(MULTIPLE_PATIENT_LIST, JSON.stringify([]));
      this.setState({ loading: true });
      if (!patientId) {
        patientId = this.state.selectedPatientId;
        patientInfo = this.state.patientInfo;
      }
      let showNotification = {};
      let apiUrl = apiPath.getPatientList + "/" + patientId;
      const response = fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      })
        .then((response) => {
          if (response.status === 400) {
            showNotification = {
              title: "Patient Detail",
              message: "Bad response from server",
              type: "danger",
            };
          } else if (response.ok) {
          } else if (response.status === 401) {
            userService.logout();
            //window.location.reload(true);
            window.location.replace(baseRoutes.login.path);
          } else {
            showNotification = {
              title: "Patient Detail",
              message: "Bad response from server",
              type: "danger",
            };
          }

          return response.json();
        })
        .then((data) => {
          const {
            patientId,
            firstName,
            middleName,
            lastName,
            patientCatagoryMapping,
            thirdPartyPatientId,
          } = data[0];
          sessionStorage.setItem("patientInfo", JSON.stringify(data[0]));
          localStorage.setItem("patientInfo", JSON.stringify(data[0]));
          const patientCategoryList = [];
          let referralSent = false;
          patientCatagoryMapping.map((el) => {
            if (el.refferalId) {
              referralSent = true;
            }
            return patientCategoryList.push(el.categoryId);
          });
          let patientList = [];
          patientList = this.state.patientList.map((pList, key) => {
            if (pList.patientId == data[0].patientId) {
              pList = data[0];
            }
            return pList;
          });
          sessionStorage.setItem(PATIENT_LIST, JSON.stringify(patientList));

          // The DP ticked another patient while this was in flight, so this response is
          // describing a selection that no longer exists. The patient data above is still
          // worth keeping — it is per-patient and correct — but writing the selection
          // fields below would drop everything ticked since.
          if (seq !== undefined && seq !== this.selectionSeq) {
            this.setState({ loading: false, patientList: patientList });
            return true;
          }

          this.setState({
            selectedPatientId: patientId,
            patientName:
              (lastName ? lastName : "") +
              ", " +
              firstName +
              " " +
              (middleName ? middleName : ""),
            patientCategoryList: patientCategoryList,
            selectionCount: 1,
            selectedPatientData: data[0],
            loading: false,
            multiPatientMode: false,
            patientList: patientList,
            patientTaskList: data[0].patientTask ? data[0].patientTask : [],
            multiplePatientList: [patientId],
            selectRemovePatient:
              thirdPartyPatientId && !referralSent ? [thirdPartyPatientId] : [],
          });
          window.dispatchEvent(new Event("resize"));
          this.fetchTasks(patientId);
          return true;
        })
        .catch((error) => {
          showNotification = {
            title: "Patient Detail",
            message: "Bad response from server",
            type: "danger",
          };
          this.setState({ loading: false });
          return response;
        });
      userService.showNotification(showNotification);
    } catch (error) {
      this.setState({ loading: false });
    }
  };
  fetchPatientList = (patientId, patientInfo) => {
    // Any tick invalidates a patient fetch already in flight.
    const seq = ++this.selectionSeq;
    // Copy, not the state array itself: pushing into this.state.multiplePatientList
    // mutated state in place, so React could not see the change and the previous value
    // was gone before anything could compare against it.
    let selectedPatients = [...this.state.multiplePatientList];
    if (selectedPatients.includes(patientId)) {
      const index = selectedPatients.indexOf(patientId);
      if (index > -1) {
        selectedPatients.splice(index, 1);
      }
    } else {
      selectedPatients.push(patientId);
    }
    let selectRemovePatient = [...this.state.selectRemovePatient];
    if (
      patientInfo &&
      patientInfo.thirdPartyPatientId &&
      !patientInfo.referralSent
    ) {
      console.log(
        "remove top",
        patientInfo.thirdPartyPatientId,
        selectRemovePatient
      );
      if (selectRemovePatient.includes(patientInfo.thirdPartyPatientId)) {
        const index = selectRemovePatient.indexOf(
          patientInfo.thirdPartyPatientId
        );
        if (index > -1) {
          selectRemovePatient.splice(index, 1);
        }
      } else {
        selectRemovePatient.push(patientInfo.thirdPartyPatientId);
      }
      console.log(
        "remove bottom",
        patientInfo.thirdPartyPatientId,
        selectRemovePatient
      );
    }
    this.setState({
      selectedPatientId: "",
      selectedPatientData: {},
    });
    selectedPatients = selectedPatients.sort(function (a, b) {
      return b - a;
    });
    if (selectedPatients.length) {
      if (selectedPatients.length > 1) {
        try {
          this.setState({ loading: true });
          let data = {
            ids: selectedPatients,
          };
          let showNotification = {};
          let apiUrl = apiPath.multiSelectPatientCat;
          const response = fetch(apiUrl, {
            method: "POST",
            headers: generalAuthTokenHeader(),
            body: JSON.stringify(data),
            data: JSON.stringify(data),
          })
            .then((response) => {
              if (response.status === 400) {
                showNotification = {
                  title: "Patient Detail",
                  message: "Bad response from server",
                  type: "danger",
                };
              } else if (response.ok) {
              } else if (response.status === 401) {
                userService.logout();
                //window.location.reload(true);
                window.location.replace(baseRoutes.login.path);
              } else {
                showNotification = {
                  title: "Patient Detail",
                  message: "Bad response from server",
                  type: "danger",
                };
              }
              this.setState({ loading: false });
              return response.json();
            })
            .then((data) => {
              if (data && data.length) {
                this.setState({
                  patientCategoryList: data,
                });
              } else {
                this.setState({
                  patientCategoryList: [],
                });
              }
              return true;
            })
            .catch((error) => {
              showNotification = {
                title: "Patient Detail",
                message: "Bad response from server",
                type: "danger",
              };
              this.setState({ loading: false });
              this.setState({
                patientCategoryList: [],
              });
              return response;
            });
          userService.showNotification(showNotification);
        } catch (error) {
          this.setState({ loading: false });
        }
      }
      sessionStorage.setItem(
        MULTIPLE_PATIENT_LIST,
        JSON.stringify(selectedPatients)
      );
      if (selectedPatients.length > 1) {
        this.setState({
          multiPatientMode: true,
          multiplePatientList: selectedPatients,
          selectionCount: selectedPatients.length,
          selectRemovePatient: selectRemovePatient,
        });
      } else {
        this.setState({
          multiPatientMode: false,
          multiplePatientList: selectedPatients,
          selectionCount: selectedPatients.length,
          selectRemovePatient: selectRemovePatient,
        });
        if (this.state.selectedPatientId != selectedPatients[0]) {
          this.fetchPatientInfo(selectedPatients[0], patientInfo, seq);
        }
      }
    } else {
      this.setState({
        multiPatientMode: false,
        multiplePatientList: [],
        selectionCount: 0,
        selectedPatientId: "",
        selectRemovePatient: [],
        selectedPatientData: {},
      });
    }
  };
  fetchPatientTasks = (patientId) => {
    try {
      this.setState({ loading: true });
      let showNotification = {};

      let apiUrl = apiPath.getPatientTasks + "/" + patientId;
      const response = fetch(apiUrl, {
        method: "GET",
        headers: generalAuthTokenHeader(),
      })
        .then((response) => {
          if (response.status === 400) {
            showNotification = {
              title: "Patient Tasks",
              message: "Bad response from server",
              type: "danger",
            };
          } else if (response.ok) {
          } else if (response.status === 401) {
            userService.logout();
            //window.location.reload(true);
            window.location.replace(baseRoutes.login.path);
          } else {
            showNotification = {
              title: "Patient Tasks",
              message: "Bad response from server",
              type: "danger",
            };
          }

          return response.json();
        })


        .then((data) => {
          console.log(" tasks: data,", data,);
          this.setState({

            tasks: data,
          });
          sessionStorage.setItem("tasks", JSON.stringify(data));

          window.dispatchEvent(new Event("resize"));
          return true;
        })
        .catch((error) => {
          showNotification = {
            title: "Patient Tasks",
            message: "Bad response from server",
            type: "danger",
          };
          this.setState({ loading: false });
          // this.state.spinner.setAttribute('hidden', 'true');
          return response;
        });
      userService.showNotification(showNotification);
    } catch (error) {
      this.setState({ loading: false });
    }
  };
  loadMorePatient() {
    let localPatientList = this.state.patientList;
    this.setState(
      {
        loadMore: false,
      },
      () => this.fetchPatients()
    );
  }
  formatDateToLocalFormat(serverDate) {
    var dateObj = new Date(serverDate);
    var month = dateObj.getMonth() + 1; //months from 1-12
    var day = dateObj.getDate();
    var year = dateObj.getFullYear();
    return month + "/" + day + "/" + year;
  }
  formatDateToServerFormat(localDate) {
    var dateObj = new Date(localDate);
    var month = dateObj.getMonth() + 1; //months from 1-12
    month = month < 10 ? "0" + month : "" + month;
    var day = dateObj.getDate();
    day = day < 10 ? "0" + day : "" + day;
    var year = dateObj.getFullYear();
    return year + "-" + month + "-" + day;
  }
  /**
   * One icon in the patient card's name row that reveals a single field on click.
   *
   * The old card printed DOB, Status, Insurance and Location as visible text, which is most of
   * the card's vertical space for four values a DP scans only occasionally. Behind icons the
   * row stays one line and the name leads.
   *
   * Click, not hover, per the design — and clicks must stopPropagation because the card is
   * wrapped in an onClick that opens the patient.
   */
  renderCardInfoIcon = (popKey, label, value, tone, path) => {
    return (
      <CustomTooltip
        arrow
        placement="top"
        enterDelay={150}
        title={
          <span className="pd-pop">
            <span className="pd-pop-label">{label}</span>
            <span className={`pd-pop-value pd-tone-${tone}`}>{value || "N/A"}</span>
          </span>
        }
      >
        <button
          type="button"
          className={`pd-icon-btn pd-tone-${tone}`}
          // aria-label, not title: a native title tooltip pops up on hover over
          // the same icon and competes with the click popover, which makes it
          // look like the popover is only showing a label.
          aria-label={label + ": " + (value || "N/A")}
          // Shows on hover now, not click. The click handler stays only to swallow
          // the event: the whole card is wrapped in an onClick that opens the
          // patient, so a stray click on an icon would navigate away.
          onClick={(e) => e.stopPropagation()}
        >
          <svg
            width="16"
            height="16"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            {path}
          </svg>
        </button>
      </CustomTooltip>
    );
  };

  patientListRender = (pList, key) => {
    const {
      patientId,
      firstName,
      middleName,
      lastName,
      eastimatedDischargeDate,
      actualDischargeDate,
      primaryDiagnosis,
      reasonForSnfStay,
      formattedPatientDob,
      formattedEstimatedDischargeDate,
      insuranceId,
      patientStatusId,
      patientStatus,
      notificationCount,
      previousHospitalId,
      patientCatagoryMapping,
      patientDob,
      pccPatientsEntity,
      riskStatus, // <-- NEW field from API
    } = pList;
    const { facilityType } = this.state;
    // MM/DD/YY on the discharge dates — the client asked for "/26" not "/2026". DOB keeps
    // its four-digit year below: a two-digit birth year is genuinely ambiguous.
    let localEstMoment = eastimatedDischargeDate
      ? moment.utc(eastimatedDischargeDate).format("MM/DD/YY")
      : "N/A";
    let localActualEstMoment = actualDischargeDate
      ? moment.utc(actualDischargeDate).format("MM/DD/YY")
      : null;
    let patientDischargedWarning =
      localActualEstMoment &&
        daysBetweenTwoDate(localActualEstMoment, new Date()) >= 30
        ? true
        : false;
    let localDobMoment = patientDob
      ? moment.utc(patientDob).format("MM/DD/YYYY")
      : "N/A";
    let admissionDate =
      pccPatientsEntity && pccPatientsEntity.admissionDate
        ? moment.utc(pccPatientsEntity.admissionDate).format("MM/DD/YYYY")
        : "N/A";

    // Insurance and location moved from their own text lines into name-row popovers, so both
    // are resolved to a display string here rather than inline in the JSX.
    let matchedInsurance =
      this.state.insuranceList && this.state.insuranceList.length
        ? this.state.insuranceList.find((el) => el.insuranceId == insuranceId)
        : null;
    let insuranceName = matchedInsurance ? matchedInsurance.insuranceName : "No Insurance";

    let locationLabel =
      pccPatientsEntity && pccPatientsEntity.floorDesc
        ? pccPatientsEntity.floorDesc +
        "-" +
        pccPatientsEntity.roomDesc +
        "-" +
        pccPatientsEntity.bedDesc
        : "N/A";

    // normalize risk status for case-insensitive check
    const normalizedRisk =
      riskStatus && typeof riskStatus === "string"
        ? riskStatus.toLowerCase()
        : null;
    return (
      <Box
        display="flex"
        flexDirection="row"
        width={1}
        key={key}
        className="pd-card-row"
      >
        <Box
          pr={1}
          className="pd-card-detail"
          onClick={() => this.handlePatientCardClick(patientId, pList)}
        >
          <div className="user-infox name-status-task-insurance pd-card-info">
                      <div className="name pd-name-row">
                {/* Name with ellipsis */}
                <span
                 title={lastName + ", " + firstName + " " + (middleName ? middleName : "")}
                  className="pd-name"
                >
                  {lastName + ", " + firstName + " " + (middleName ? middleName : "")}
                </span>


                {/* Notification dot — unread notifications on this patient's referrals,
                    addressed to the signed-in user. Colour encodes RISK, not the count.
                    notificationCount can arrive undefined, hence the fallback wording. */}
                {notificationCount !== 0 && (
                  <CustomTooltip
                    arrow
                    placement="top"
                    title={
                      notificationCount
                        ? notificationCount +
                        (notificationCount === 1
                          ? " unread message"
                          : " unread messages")
                        : "Unread messages"
                    }
                  >
                  <span>
                    <svg xmlns="http://www.w3.org/2000/svg" width="8" height="8" viewBox="0 0 8 8">
                      <circle
                        cx="4"
                        cy="4"
                        r="4"
                        fill={
                          normalizedRisk === "1" ? "red" :
                          normalizedRisk === "2" ? "#FFD700" :
                          normalizedRisk === "3" || normalizedRisk === "4" ? "green" :
                          "red"
                        }
                      />
                    </svg>
                  </span>
                  </CustomTooltip>
                )}

                {/* DOB moved up here from the facts grid, into the slot the risk pill used
                    to occupy. The pill moved down to the control row. */}
                <span className="pd-name-dob">
                  <span className="pd-fact-label">DOB:</span>
                  <strong>{localDobMoment}</strong>
                </span>


              </div>

            {/* Second line of section 1: the toggle, then what is left of the icon set. */}
            <div className="pd-control-row">
                {/* Show on / Remove from Dashboard. On EVERY tab now, including Dashboard,
                    where it is the per-row "remove" that replaced the bulk button.

                    Sits at the far left of the icon set, and slides right-to-left rather than
                    the usual left-to-right — the Dashboard is the left-most tab, so "on" moving
                    leftwards reads as moving the patient towards it. The mirroring is done in
                    CSS on .pd-dash-toggle.

                    stopPropagation matters: the whole card is wrapped in an onClick that opens
                    the patient, so without it flipping the switch would also navigate away. */}
                <CustomTooltip
                  arrow
                  placement="top"
                  title={
                    this.isShownOnDashboard(pList)
                      ? "Remove from Dashboard"
                      : "Add on Dashboard"
                  }
                >
                <span
                  className="pd-dash-toggle"
                  style={{ flexShrink: 0 }}
                  onClick={(e) => e.stopPropagation()}
                  data-tour="dashboard-toggle"
                >
                  <SwitchToggle
                    id={patientId}
                    status={this.isShownOnDashboard(pList)}
                    disabled={this.state.savingDashboardIds.includes(patientId)}
                    clickHandler={(e) => {
                      e.stopPropagation();
                      this.handleShowOnDashboardToggle(pList);
                    }}
                    ariaLabel={
                      (this.isShownOnDashboard(pList) ? "Remove " : "Show ") +
                      lastName + ", " + firstName +
                      (this.isShownOnDashboard(pList) ? " from Dashboard" : " on Dashboard")
                    }
                  />
                </span>
                </CustomTooltip>

                {/* Admitted is the only icon left — DOB, Status, Insurance and now Location
                    are all text, and Admitted is the one that went the other way. */}
                <span className="pd-icon-group">
                  {this.renderCardInfoIcon(
                    patientId + "-admitted",
                    "Admitted",
                    admissionDate,
                    "teal",
                    <path d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
                  )}
                </span>
                {/* MaxAlly invite, before the risk pill on the control row.

                    Compact by necessity: .pd-card-detail has a 360px floor and the full gradient
                    button from Patient Detail does not fit at laptop widths.

                    stopPropagation is required - the whole card is wrapped in
                    handlePatientCardClick, so without it this would select the patient or,
                    on an already-selected row, navigate to Patient Detail. */}
                <CustomTooltip
                  arrow
                  placement="top"
                  title="Invite this patient's contacts to the MaxAlly app"
                >
                  <button
                    type="button"
                    className="pd-invite-btn"
                    aria-label={"Invite " + lastName + ", " + firstName + " to MaxAlly"}
                    onClick={(e) => {
                      e.stopPropagation();
                      this.handleOpenInviteDialog(pList);
                    }}
                  >
                    <img src={maxAllyIcon} alt="" aria-hidden="true" />
                    <span>
                      {inviteButtonLabel(
                        this.state.contactCounts[patientId],
                        "Invite"
                      )}
                    </span>
                  </button>
                </CustomTooltip>

                {/* Risk status badge - soft pill per the new design, replacing the solid
                    red/yellow/green block. Colour still carries the meaning; the saturation
                    just no longer competes with the referral tags on the right.

                    Last on the control row: toggle -> icons -> INVITE -> risk. It briefly lived
                    on the meta line, because at laptop widths the details column collapsed and
                    the tags painted over whatever the name row spilled. That is fixed at the
                    column level now - .pd-card-detail holds a 360px floor and no longer shrinks
                    - so the pill is back on this row. If it ever disappears again, the column is
                    being squeezed; do not move the pill, fix the column. */}
                {(normalizedRisk === "1" || normalizedRisk === "2" || normalizedRisk === "3") && (
                  <CustomTooltip
                    arrow
                    placement="top"
                    title="AI Risk Status"
                  >
                  <span
                    className={`pd-risk-pill pd-risk-${normalizedRisk === "1" ? "high" : normalizedRisk === "2" ? "medium" : "low"
                      }`}
                  >
                    {normalizedRisk === "1" ? "High Risk" : normalizedRisk === "2" ? "Medium Risk" : "Low Risk"}
                  </span>
                  </CustomTooltip>
                )}
            </div>
          </div>

          {/* Section 2 — a 2x2 grid of the text facts, to the right of the name block.
              Est. DC and Status on the first row, Ins and Location on the second. DOB moved
              up to the name row; Location came down from being an icon. */}
          <div className="pd-facts">
            <span className="pd-fact">
              {localActualEstMoment ? (
                <>
                  <span className="pd-fact-label">DC:</span>
                  <strong className="warning-sign">
                    {localActualEstMoment}
                    {patientDischargedWarning ? (
                      <CustomTooltip title="This patient is discharged more than 30 days ago.">
                        <WarningIcon />
                      </CustomTooltip>
                    ) : null}
                  </strong>
                </>
              ) : (
                <>
                  <span className="pd-fact-label">Est. DC:</span>
                  <strong>{localEstMoment}</strong>
                </>
              )}
            </span>
            <span className="pd-fact">
              <span className="pd-fact-label">Status:</span>
              <strong>
                {patientStatus && patientStatus.patientStatusValue
                  ? patientStatus.patientStatusValue
                  : "None"}
              </strong>
            </span>
            <span className="pd-fact">
              <span className="pd-fact-label">Ins.:</span>
              <strong title={insuranceName}>{insuranceName}</strong>
            </span>
            <span className="pd-fact">
              <span className="pd-fact-label">Location:</span>
              <strong title={locationLabel}>{locationLabel}</strong>
            </span>
          </div>
        </Box>
        <Box className="list-scrollxx category-value-status-list pateint_box pd-card-tags">
          {patientCatagoryMapping && patientCatagoryMapping.length ? (
            <div className="pd-ref-scroller">
              {patientCatagoryMapping
                // .sort((a, b) => a.categoryId > b.categoryId ? 1 : -1)
                .map((el, index) => {
                  const { masterCategories, catagoryId, status } = el;

                  return (
                    <NavLink
                      key={index}
                      to={`${basePath}${dpBaseRoutes.singlePatientInfo.path
                        }?key=${el.categoryId}&mode=${btoa(
                          btoa(this.state.multiPatientMode)
                        )}&facility=${btoa(btoa(this.state.facilityType))}`}
                      onClick={() => this.categorySelection(patientId, pList)}
                    >
                      {(() => {
                        // Status drives both the label and the tag's colour. Unchanged logic:
                        // no referral yet reads "Finding", and Reviewing (status 8) appends the
                        // responded/total provider count. Only the presentation is new.
                        const statusValue =
                          el &&
                            el.refferalEntity &&
                            el.refferalEntity.masterRefferalStatusEntity
                            ? el.refferalEntity.masterRefferalStatusEntity.refferalStatusValue
                            : "Finding";
                        const providerCount =
                          el &&
                            el.refferalEntity &&
                            el.refferalEntity.refferalStatus === 8 &&
                            el.refferalEntity.refferalProviderEntity
                            ? ` (${el.refferalEntity.refferalProviderEntity.filter(p => [3, 5, 6, 9].includes(p.providerStatusId)).length}/${el.refferalEntity.refferalProviderEntity.length})`
                            : "";
                        // Original look restored at the client's request: plain bordered box,
                        // black category name, and a solid status band coloured by the legacy
                        // per-status classes in frontui.css (.Awaiting / .Finding / .Finalized /
                        // .Reviewing ...), which `${statusValue}` selects. No pd-ref-* tinting
                        // and no pulsing dot.
                        return (
                          <Box
                            className="itemx menu-itemx owl-item-box"
                            key={index}
                            id="refidoOwl"
                          >
                            <p className="category-value">
                              {masterCategories.categoryValue}
                            </p>
                            <p className={`category-status ${statusValue}`}>
                              {getStatusDisplayLabel(statusValue) + providerCount}
                            </p>
                          </Box>
                        );
                      })()}
                    </NavLink>
                  );
                })}
            </div>
          ) : (
            <div
              className="no-data-text pointer"
              onClick={() => this.categorySelection(patientId, pList)}
            >
              Select categories/Edit Patient
            </div>
          )}
        </Box>
      </Box>
    );
  };
  handleDob = (value) => {
    let dob = true;
    if (value == null || !this.dateUtility.isValid(value)) {
      dob = false;
    }
    this.setState(
      {
        dob: value,
        dobValid: dob,
      },
      () => {
        this.validateField("dob", value);
      }
    );
  };
  handleActualEstDate = (value) => {
    let actualEstDate = true;
    if (value && !this.dateUtility.isValid(value)) {
      actualEstDate = false;
    }
    console.log(value);
    this.setState(
      {
        actualEstDate: value,
        actualEstDateValid: actualEstDate,
      },
      () => {
        this.validateField("actualEstDate", value);
      }
    );
  };
  handleEstDate = (value) => {
    let estDate = true;
    if (value && !this.dateUtility.isValid(value)) {
      estDate = false;
    }
    this.setState(
      {
        estDate: value,
        estDateValid: estDate,
      },
      () => {
        this.validateField("estDate", value);
      }
    );
  };
  handleDobError(error, value) {
    this.setState({
      dobValid: error || value == "" || value == null ? false : true,
    });
  }
  handleEstDateError(error, value) {
    // console.log(error, value)
    // this.setState({
    //     estDateValid: error ? false : true
    // });
  }
  handleActualEstDateError(error, value) {
    // console.log(error, value)
    // this.setState({
    //     estDateValid: error ? false : true
    // });
  }
  handleSingleDpDChange(value, name) {
    if (!value || value == "") {
      // return;
    }
    this.setState({ [name]: value }, () => {
      this.validateField(name, value);
    });
  }
  onImageFileBrowse = (event) => {
    this.inputOpenImageFileRef.current.click();
  };
  onFaceSheetFileBrowse = (event) => {
    this.inputOpenFaceSheetFileRef.current.click();
  };
  handleImageSelectedFile = (event) => {
    event.preventDefault();
    let file = event.target.files[0];
    let fieldValidationErrors = this.state.formErrors;
    let error = "";
    let patientImageValid = false;
    if (typeof file == "object" && file.size > ALLOWED_PROFILE_IMAGE_SIZE) {
      error = enMsg.allowedProfileImageSize;
    } else if (
      typeof file == "object" &&
      !ALLOWED_IMAGE_EXTENTION.includes(file.type)
    ) {
      error = enMsg.allowedProfileImageType;
    } else {
      patientImageValid = true;
    }
    if (typeof file !== undefined && file && patientImageValid) {
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        let result = fileReader.result;
        this.setState({
          patientImage: result,
          patientImageName: file.name,
          isImage: true,
        });
        this.patientImageBlob = file;
        this.patientImageName = file.name;
      });
      if (file) {
        fileReader.readAsDataURL(file);
      }
    }
    fieldValidationErrors.patientImage = patientImageValid ? "" : error;
    this.setState(
      {
        patientImageValid: patientImageValid,
        formErrors: fieldValidationErrors,
      },
      this.validateForm
    );
  };
  handleFaceSheetSelectedFile = (event) => {
    event.preventDefault();
    let file = event.target.files[0];
    let fieldValidationErrors = this.state.formErrors;
    let error = "";
    let patientFaceSheetValid = false;
    if (typeof file == "object" && file.size > ALLOWED_FACESHEET_SIZE) {
      error = enMsg.allowedFaceSheetSize;
    } else if (
      typeof file == "object" &&
      !ALLOWED_FACESHEET_EXTENTION.includes(file.type)
    ) {
      error = enMsg.allowedFaceSheetType;
    } else {
      patientFaceSheetValid = true;
    }
    if (typeof file !== undefined && file && patientFaceSheetValid) {
      const fileReader = new FileReader();
      fileReader.addEventListener("load", () => {
        let result = fileReader.result;
        this.setState({
          patientFaceSheet: result,
          patientFaceSheetName: file.name,
          isFaceSheet: true,
        });
        this.patientFaceSheetBlob = file;
        this.patientFaceSheetName = file.name;
      });
      if (file) {
        fileReader.readAsDataURL(file);
      }
    }
    fieldValidationErrors.patientFaceSheet = patientFaceSheetValid ? "" : error;
    this.setState(
      {
        patientFaceSheetValid: patientFaceSheetValid,
        formErrors: fieldValidationErrors,
      },
      this.validateForm
    );
  };
  getBase64(file, cb) {
    let reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = function () {
      cb(reader.result);
    };
    reader.onerror = function (error) { };
  }
  selectPatientCategory = (catagoryId) => {
    let patientCategories = this.state.patientCategories;
    if (patientCategories.includes(catagoryId)) {
      const index = patientCategories.indexOf(catagoryId);
      if (index > -1) {
        patientCategories.splice(index, 1);
      }
    } else {
      patientCategories.push(catagoryId);
    }
    this.setState(
      {
        patientCategories: patientCategories,
      },
      () => {
        this.validateField("patientCategoties", patientCategories);
      }
    );
  };
  imageFilesRemoveAll(fileType) {
    let fieldValidationErrors = this.state.formErrors;
    if (fileType == "facesheet") {
      fieldValidationErrors.patientFaceSheet = "";
      this.setState({
        isFaceSheet: false,
        patientFaceSheetValid: true,
        formErrors: fieldValidationErrors,
      });
      this.refs.patientFaceSheets.removeFiles();
    } else {
      fieldValidationErrors.patientImage = "";
      this.setState({
        isImage: false,
        patientImageValid: true,
        formErrors: fieldValidationErrors,
      });
      this.refs.patientImages.removeFiles();
    }
  }
  imageFilesRemoveOne(file, fileType) {
    let fieldValidationErrors = this.state.formErrors;
    if (fileType == "facesheet") {
      fieldValidationErrors.patientFaceSheet = "";
      this.setState({
        patientFaceSheetValid: true,
        formErrors: fieldValidationErrors,
      });
      this.refs.patientFaceSheets.removeFile(file);
    } else {
      fieldValidationErrors.patientImage = "";
      this.setState({
        patientImageValid: true,
        formErrors: fieldValidationErrors,
      });
      this.refs.patientImages.removeFile(file);
    }
  }
  onImageFilesChange = (patientImages) => {
    this.setState({
      patientImages,
    });
  };
  onFaceSheetFilesChange = (patientFaceSheets) => {
    this.setState({
      patientFaceSheets,
    });
  };
  fileSelectClick = (fileType) => {
    let fieldValidationErrors = this.state.formErrors;
    if (fileType == "facesheet") {
      fieldValidationErrors.patientFaceSheet = "";
      this.setState({
        isFaceSheet: false,
        patientFaceSheetValid: true,
        formErrors: fieldValidationErrors,
        patientFaceSheetsStr: [],
      });
    } else {
      fieldValidationErrors.patientImage = "";
      this.setState({
        isImage: false,
        patientImageValid: true,
        formErrors: fieldValidationErrors,
        patientImagesStr: [],
      });
    }
  };
  onImageFilesError = (error, file) => {
    let errorMsg = "";
    switch (error.code) {
      case 1:
        errorMsg = error.message;
        break;
      case 2:
        errorMsg = error.message;
        break;
      case 3:
        errorMsg = error.message;
        break;
      case 4:
        errorMsg = error.message;
        break;
      default:
        errorMsg = "File not found";
        break;
    }
    let fieldValidationErrors = this.state.formErrors;
    let patientImageValid = false;
    fieldValidationErrors.patientImage = patientImageValid ? "" : errorMsg;
    this.setState(
      {
        patientImageValid: patientImageValid,
        formErrors: fieldValidationErrors,
      },
      this.validateForm
    );
  };
  onFaceSheetFilesError = (error, file) => {
    let errorMsg = "";
    switch (error.code) {
      case 1:
        errorMsg = error.message;
        break;
      case 2:
        errorMsg = error.message;
        break;
      case 3:
        errorMsg = error.message;
        break;
      case 4:
        errorMsg = error.message;
        break;
      default:
        errorMsg = "File not found";
        break;
    }
    let fieldValidationErrors = this.state.formErrors;
    let patientFaceSheetValid = false;
    fieldValidationErrors.patientFaceSheet = patientFaceSheetValid
      ? ""
      : errorMsg;
    this.setState(
      {
        patientFaceSheetValid: patientFaceSheetValid,
        formErrors: fieldValidationErrors,
      },
      this.validateForm
    );
  };
  loaderStatus = (status) => {
    this.setState({
      loading: status,
    });
  };
  closeImportModal = () => {
    this.setState({
      importModal: false,
    });
  };
  handleAssignedSuccess = () => {
    // this.setState({
    //     importModal: false,
    // }, () => this.fetchPatients())
    this.fetchPatients();
  };
  handleRemovedSuccess = () => {
    this.setState(
      {
        selectRemovePatient: [],
      },
      () => this.fetchPatients()
    );
    // this.fetchPatients()
  };
  getTaskClass = (patientTasks) => {
    if (patientTasks.length == 0) return "task2";
    const patientTasksStatus = patientTasks.map((value) => value.changeStatus);
    var patientTasksStatusSet = new Set(patientTasksStatus);

    if (patientTasksStatusSet.size == 1 && patientTasksStatusSet.has(6)) {
      return "task2";
    }
    return "task1";
  };
  async fetchTasks(patientId, selectedPatientId) {

    try {

      let apiUrl = apiPath.GetGroupPatient + '/' + patientId;

      console.log('Fetching tasks from API:', apiUrl); // Log API endpoint URL

      const response = await fetch(apiUrl, {
        method: 'GET',
        headers: generalAuthTokenHeader()
      });

      if (!response.ok) {
        throw new Error(`Failed to fetch patient tasks. Status: ${response.status}`);
      }

      const data = await response.json();
      console.log('API Response: patientTaskGroup', data); // Log API response data
      sessionStorage.setItem("patientTaskGroup", JSON.stringify(data));

      this.setState({
        patientTaskGroup: data,


      });
    } catch (error) {
      console.log(error); // Log any errors
    } finally {
      this.setState({ loading: false });

    }
  }


  render() {
    const {
      currentPage,
      total,
      sorting,
      filter,
      patientCategoryList,
      loading,
      patientName,
      selectedPatientId,
      patientList,
      hospital,
      insurance,
      gender,
      insuranceList,
      categoryList,
      hospitalList,
      patientCategories,
      selectionCount,
      totalPatientShowing,
      tasks,
      facilityType,
      patientFilterList,
      patientTaskGroup
    } = this.state;
    // Both facility types have a tab bar now. A vendor facility gets all five tabs; a
    // hand-entry facility gets Dashboard and All Patients only — the other three read
    // admission_date, which manual patients never have. Same facilityCode-derived
    // discriminator the Add-vs-Import swap below already uses.
    const isVendorFacility = facilityType === VENDOR_FACILITY;
    const visibleTabs = isVendorFacility
      ? PATIENT_TABS
      : PATIENT_TABS.filter((t) => t.manual);
    // facilityType is "" until the DP record loads; holding the bar back until then keeps a
    // one-frame five-tab flash off a manual facility's screen.
    const showTabs = !!facilityType;
    const { classes } = this.props;
    // const menu = this.menuItems;
    return (
      <div id="facility-index">
        {/* <iframe src="https://connect.pointclickcare.com/auth/login?client_id=eN2VehceGkQAe9XfDKZfl9WfAtoeYyaQ&response_type=OAuth2&redirect_uri=http://localhost:3000/maxmrj/login&state=5455"/> */}
        <ChangePassword
          id="change-pssword-dialog"
          keepMounted
          open={this.state.openModal}
          handleChangePasswordDialog={this.handleClose}
          onClose={this.handleClose}
          value={""}
          allowCloseModal={false}
        />
        <BAAComponent
          open={this.state.bbaCondition}
          handleBAAAgree={this.handleBAAAgree}
        />
        <TermsComponent
          open={this.state.termNcondition}
          handleTNCAgree={this.handleTNCAgree}
        />
        <ImportPatientModal
          showModal={this.state.importModal}
          handleCancel={this.closeImportModal}
          handleAssignedSuccess={this.handleAssignedSuccess}
          handleRemovedSuccess={this.handleRemovedSuccess}
          patientFilterList={patientFilterList}
          reduxLoadFlag={this.state.reduxLoadFlag}
          selectRemovePatient={this.state.selectRemovePatient}
        />
        <ConfirmModal
          title="Confirm"
          message={this.state.confirmModalMessage}
          confirmModalStatus={this.state.confirmModalStatus}
          confirmModalClose={this.confirmModalClose}
          submit={this.confirmModalSubmit}
          loading={this.state.loading}
        />
        {this.state.tourSteps && this.state.tourSteps.length ? (
          <DashboardTour steps={this.state.tourSteps} onClose={this.handleTourClose} />
        ) : null}
        {/* Rendered only while open so each invite starts from a clean dialog — ContactDialog
            caches the contact list in its own state once it has been edited. */}
        {this.state.openContactDialog && this.state.contactPatient ? (
          <ContactDialog
            open={this.state.openContactDialog}
            onClose={this.closeInviteDialog}
            contactList={this.state.contactList}
            patientId={this.state.contactPatient.patientId}
            patientName={this.state.contactPatient.patientName}
            estimatedDischargeDate={this.state.contactPatient.estimatedDischargeDate}
            onUpdateEstimatedDischargeDate={this.handleUpdateEstimatedDischargeDate}
            onUpdate={() => this.fetchContactList()}
          />
        ) : null}
        {/* Separate from ConfirmModal above, which is committed to the PCC unassign flow. */}
        <Dialog
          open={this.state.removeFromDashboardConfirmOpen}
          onClose={this.closeRemoveFromDashboardConfirm}
          maxWidth="xs"
          fullWidth
        >
          <DialogTitle>Remove from Dashboard</DialogTitle>
          <DialogContent>
            <Typography variant="body2">
              Remove <b>{this.state.multiplePatientList.length}</b> selected patient(s)
              from the Dashboard?
            </Typography>
            <Typography variant="body2" style={{ marginTop: 8, color: "#4C4C4C" }}>
              They stay in MaxMRJ — you can find them in the <b>All Patients</b> tab and
              switch &quot;Show on Dashboard&quot; back on at any time.
            </Typography>
          </DialogContent>
          <DialogActions>
            <Button
              onClick={this.closeRemoveFromDashboardConfirm}
              color="secondary"
              disabled={this.state.removingFromDashboard}
            >
              Cancel
            </Button>
            <Button
              onClick={this.confirmRemoveFromDashboard}
              color="primary"
              variant="contained"
              disabled={this.state.removingFromDashboard}
            >
              Remove
            </Button>
          </DialogActions>
        </Dialog>
        <Dialog
          open={this.state.modalStatus}
          maxWidth={"sm"}
          onClose={this.modalClose}
          scroll="body"
          TransitionComponent={Transition}
          aria-labelledby="form-dialog-title"
          className="add-modal front-modal modalFitOnScreen new-modal"
        >
          <DialogTitle className="add-modal-title" id="form-dialog-title">
            {this.state.selectedPatientId ? "Edit Patient" : "Add New Patient"}
            <IconButton
              className="closeButton"
              aria-label="close"
              onClick={this.modalClose}
            >
              <CloseIcon />
            </IconButton>
          </DialogTitle>
          <form onSubmit={this.handleSubmit} noValidate>
            <DialogContent>
              <Box
                width={1}
                display="flex"
                justifyContent="flex-start"
                mb={1}
                mt={1}
              >
                <Box width={1 / 2} pr={2}>
                  <TextField
                    InputLabelProps={{ className: "required-label" }}
                    name="firstName"
                    label="First Name"
                    value={this.state.firstName}
                    onChange={this.handleChangeInput}
                    inputProps={{ maxLength: MAX_INPUT_LENGTH }}
                    disabled={
                      this.state.selectedPatientData &&
                        this.state.selectedPatientData.thirdPartyPatientId
                        ? true
                        : false
                    }
                  // inputProps={{ maxLength: MAX_INPUT_LENGTH, pattern: "/[^A-Za-z\d]/" }}
                  />
                  <FormErrors
                    show={!this.state.firstNameValid}
                    formErrors={this.state.formErrors}
                    fieldName="firstName"
                  />
                </Box>
                <Box width={1 / 2} pl={2}>
                  <TextField
                    InputLabelProps={{ className: "required-label" }}
                    name="lastName"
                    value={this.state.lastName}
                    onChange={this.handleChangeInput}
                    data-validators="isRequired"
                    label="Last Name"
                    inputProps={{ maxLength: MAX_INPUT_LENGTH }}
                    disabled={
                      this.state.selectedPatientData &&
                        this.state.selectedPatientData.thirdPartyPatientId
                        ? true
                        : false
                    }
                  />
                  <FormErrors
                    show={!this.state.lastNameValid}
                    formErrors={this.state.formErrors}
                    fieldName="lastName"
                  />
                </Box>
              </Box>
              <Box width={1} display="flex" justifyContent="flex-start" mb={1}>
                <Box width={1 / 2} pr={2}>
                  <TextField
                    // InputLabelProps={{ className: "required-label" }}
                    name="middleName"
                    value={this.state.middleName ? this.state.middleName : ""}
                    onChange={this.handleChangeInput}
                    // data-validators="isRequired"
                    label="Middle Name"
                    placeholder="Middle Name"
                    inputProps={{ maxLength: MAX_INPUT_LENGTH }}
                    disabled={
                      this.state.selectedPatientData &&
                        this.state.selectedPatientData.thirdPartyPatientId
                        ? true
                        : false
                    }
                  />
                  <FormErrors
                    show={!this.state.middleNameValid}
                    formErrors={this.state.formErrors}
                    fieldName="middleName"
                  />
                </Box>
                <Box width={1 / 2} pl={2}>
                  <FormControl>
                    <InputLabel className={"required-label"}>Gender</InputLabel>
                    <Select
                      id="gender"
                      color="secondary"
                      name="gender"
                      value={gender}
                      disabled={
                        this.state.selectedPatientData &&
                          this.state.selectedPatientData.thirdPartyPatientId
                          ? true
                          : false
                      }
                      onChange={(event) =>
                        this.handleSingleDpDChange(event.target.value, "gender")
                      }
                    >
                      <MenuItem value="">Select Gender</MenuItem>
                      <MenuItem key={"male"} value={"male"}>
                        Male
                      </MenuItem>
                      <MenuItem key={"female"} value={"female"}>
                        Female
                      </MenuItem>
                      <MenuItem key={"other"} value={"other"}>
                        Other
                      </MenuItem>
                    </Select>
                    <FormErrors
                      show={!this.state.genderValid}
                      formErrors={this.state.formErrors}
                      fieldName="gender"
                    />
                  </FormControl>
                </Box>
              </Box>
              <Box width={1} display="flex" justifyContent="flex-start" mb={1}>
                <Box width={1 / 2} pr={2}>
                  <FormControl variant="outlined">
                    <MuiPickersUtilsProvider
                      variant="outlined"
                      utils={DateFnsUtils}
                    >
                      <KeyboardDatePicker
                        // variant="inline"

                        label="Date Of Birth"
                        format="MM/dd/yyyy"
                        margin="normal"
                        id="start-date-picker-dialog"
                        // InputProps={{ autoComplete: "off" }}
                        InputLabelProps={{
                          className: "required-label",
                        }}
                        name="dob"
                        animateYearScrolling={true}
                        value={this.state.dob}
                        maxDate={this.maxDate}
                        // minDate={this.minDate}
                        maxDateMessage={enMsg.dobMaxDate}
                        onChange={this.handleDob}
                        onError={this.handleDobError}
                        className="KeyboardDatePicker"
                        invalidDateMessage={enMsg.invalidDate}
                        // closeAfterSelect={true}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                          className: "date-picker-span",
                        }}
                        disabled={
                          this.state.selectedPatientData &&
                            this.state.selectedPatientData.thirdPartyPatientId
                            ? true
                            : false
                        }
                      />
                    </MuiPickersUtilsProvider>
                    <FormErrors
                      show={!this.state.dobValid}
                      formErrors={this.state.formErrors}
                      fieldName="dob"
                    />
                  </FormControl>
                </Box>
                <Box width={1 / 2} pl={2}>
                  <FormControl>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        // variant="inline"

                        label="Estimated Discharge Date"
                        format="MM/dd/yyyy"
                        margin="normal"
                        id="start-date-picker-dialog"
                        InputLabelProps={
                          {
                            // className: "required-label"
                          }
                        }
                        InputProps={{ autoComplete: "off" }}
                        name="estDate"
                        animateYearScrolling={true}
                        value={this.state.estDate}
                        // minDate={this.minDate}
                        // minDateMessage={enMsg.estMinDate}
                        onChange={this.handleEstDate}
                        onError={this.handleEstDateError}
                        className="KeyboardDatePicker"
                        invalidDateMessage={enMsg.invalidDate}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                          className: "date-picker-span",
                        }}
                      // disabled={this.state.selectedPatientData && this.state.selectedPatientData.thirdPartyPatientId ? true : false}
                      />
                    </MuiPickersUtilsProvider>
                    <FormErrors
                      show={!this.state.estDateValid}
                      formErrors={this.state.formErrors}
                      fieldName="estDate"
                    />
                  </FormControl>
                </Box>
              </Box>
              <Box width={1} display="flex" justifyContent="flex-start" mb={1}>
                <Box width={1 / 2} pr={2}>
                  <FormControl>
                    <MuiPickersUtilsProvider utils={DateFnsUtils}>
                      <KeyboardDatePicker
                        label="Discharge Date"
                        format="MM/dd/yyyy"
                        margin="normal"
                        id="start-date-picker-dialog"
                        InputLabelProps={
                          {
                            // className: "required-label"
                          }
                        }
                        InputProps={{ autoComplete: "off" }}
                        name="actualEstDate"
                        animateYearScrolling={true}
                        value={this.state.actualEstDate}
                        // minDate={this.minDate}
                        maxDate={new Date()}
                        maxDateMessage={enMsg.maxDate}
                        onChange={this.handleActualEstDate}
                        onError={this.handleActualEstDateError}
                        className="KeyboardDatePicker"
                        invalidDateMessage={enMsg.invalidDate}
                        KeyboardButtonProps={{
                          "aria-label": "change date",
                          className: "date-picker-span",
                        }}
                        disabled={
                          this.state.selectedPatientData &&
                            this.state.selectedPatientData.thirdPartyPatientId
                            ? true
                            : false
                        }
                      />
                    </MuiPickersUtilsProvider>
                    <FormErrors
                      show={!this.state.actualEstDateValid}
                      formErrors={this.state.formErrors}
                      fieldName="actualEstDate"
                    />
                  </FormControl>
                </Box>
                <Box width={1 / 2} pl={2}>
                  <FormControl fullWidth>
                    <TextField
                      label="Benefit Days Remaining"
                      margin="normal"
                      name="benefitDaysRemaining"
                      type="number"
                      value={this.state.benefitDaysRemaining}
                      onChange={(e) => {
                        const value = e.target.value;
                        this.setState({ benefitDaysRemaining: value }, () => {
                          this.validateField("benefitDaysRemaining", value);
                        });
                      }}
                      InputProps={{
                        inputProps: { min: 1 },
                        autoComplete: "off"
                      }}
                      placeholder="Enter benefit days"
                    />
                    <FormErrors
                      show={!this.state.benefitDaysRemainingValid}
                      formErrors={this.state.formErrors}
                      fieldName="benefitDaysRemaining"
                    />
                  </FormControl>
                </Box>
              </Box>
              <Box width={1} display="flex" justifyContent="flex-start" mb={1}>
                <Box width={1 / 2} pr={2}>
                  <FormControl>
                    <InputLabel>Insurance</InputLabel>
                    <Select
                      id="insurance"
                      color="secondary"
                      name="insurance"
                      value={insurance}
                      onChange={(event) =>
                        this.handleSingleDpDChange(
                          event.target.value,
                          "insurance"
                        )
                      }
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 48 * 4.5 + 8,
                            width: 250,
                          },
                        },
                        variant: "menu",
                        getContentAnchorEl: null,
                      }}
                    >
                      <MenuItem value={0}>No Insurance</MenuItem>
                      {typeof insuranceList === "object" && insuranceList.length
                        ? insuranceList
                          // .sort((a, b) => a.insuranceId > b.insuranceId ? 1 : -1)
                          .map((iList, key) => {
                            if (iList.insuranceId != 0) {
                              return (
                                <MenuItem
                                  key={"insurance_" + iList.insuranceId}
                                  value={iList.insuranceId}
                                >
                                  {iList.insuranceName}
                                </MenuItem>
                              );
                            }
                          })
                        : null}
                    </Select>
                    <FormErrors
                      show={!this.state.insuranceValid}
                      formErrors={this.state.formErrors}
                      fieldName="insurance"
                    />
                  </FormControl>
                </Box>
                <Box width={1 / 2} pl={2}>
                  <FormControl className="pos-rel">
                    <InputLabel>Hospital Restriction </InputLabel>
                    <Select
                      id="hospital"
                      color="secondary"
                      name="hospital"
                      value={hospital}
                      onChange={(event) =>
                        this.handleSingleDpDChange(
                          event.target.value,
                          "hospital"
                        )
                      }
                      MenuProps={{
                        PaperProps: {
                          style: {
                            maxHeight: 48 * 4.5 + 8,
                            width: 250,
                          },
                        },
                        variant: "menu",
                        getContentAnchorEl: null,
                      }}
                    >
                      <MenuItem value="">Select Hospital</MenuItem>
                      {typeof hospitalList === "object" && hospitalList.length
                        ? hospitalList.map((hList, key) => {
                          return (
                            <MenuItem
                              className={
                                filter !== key ? "sorting-items" : ""
                              }
                              key={key}
                              value={hList.previousHospitalId}
                            >
                              {hList.hospitalName}
                            </MenuItem>
                          );
                        })
                        : null}
                    </Select>
                    <FormErrors
                      show={!this.state.hospitalValid}
                      formErrors={this.state.formErrors}
                      fieldName="hospital"
                    />
                    <Tooltip title="Select Hospital" placement="top" arrow>
                      <img className="info-icon" src={infoIcon} />
                    </Tooltip>
                  </FormControl>
                </Box>
              </Box>
              {this.state.selectedPatientId && (
  <Box display="flex" justifyContent="flex-start" mb={1}>
    <Box width={1 / 2} pr={2}>
      <TextField
        label="Primary Diagnosis"
        name="primaryDiagnosis"
        value={this.state.primaryDiagnosis}
        onChange={this.handleChangeInput}
        multiline
        rows={4}
        fullWidth
        color="secondary"
        inputProps={{ maxLength: 1000 }}
        InputLabelProps={{
          className: "required-label",
        }}
        className="comment-TextField"
      />
      <FormErrors
        show={!this.state.primaryDiagnosisValid}
        formErrors={this.state.formErrors}
        fieldName="primaryDiagnosis"
      />
    </Box>

    <Box width={1 / 2} pl={2}>
      <TextField
        label="Reason for SNF Stay"
        name="reasonForSnfStay"
        value={this.state.reasonForSnfStay}
        onChange={this.handleChangeInput}
        multiline
        rows={4}
        fullWidth
        color="secondary"
        inputProps={{ maxLength: 1000 }}
        InputLabelProps={{
          className: "required-label",
        }}
        className="comment-TextField"
      />
      <FormErrors
        show={!this.state.reasonForSnfStayValid}
        formErrors={this.state.formErrors}
        fieldName="reasonForSnfStay"
      />
    </Box>
  </Box>
)}

              <Box
                width={1}
                display="flex"
                justifyContent="flex-start"
                mb={1}
                style={{ display: "" }}
              >
                <Box width={1 / 2} pr={2} className="upload-links">
                  <FormControl>
                    <div className="form-caption">Documents</div>
                    <Files
                      ref="patientFaceSheets"
                      className="files-dropzone-list"
                      onChange={this.onFaceSheetFilesChange}
                      onError={this.onFaceSheetFilesError}
                      accepts={[
                        "image/png",
                        "image/x-png",
                        "image/jpg",
                        "image/jpeg",
                        "application/pdf",
                      ]}
                      multiple
                      maxFiles={20}
                      maxFileSize={1024 * 1024 * 20}
                      minFileSize={0}
                      clickable
                    >
                      <Button
                        className="btn1"
                        onClick={() => this.fileSelectClick("facesheet")}
                      >
                        <MaterialLink className="pointer">
                          <i className="fa fa-upload" aria-hidden="true"></i>{" "}
                          Upload
                        </MaterialLink>
                      </Button>
                    </Files>
                    <FormErrors
                      show={!this.state.patientFaceSheetValid}
                      formErrors={this.state.formErrors}
                      fieldName="patientFaceSheet"
                    />
                    {this.state.patientFaceSheets.length > 0 ? (
                      <List>
                        <span
                          className="pemoveAllLink"
                          onClick={() => this.imageFilesRemoveAll("facesheet")}
                        >
                          Remove All Files
                          <IconButton edge="end" aria-label="delete all">
                            <DeleteIcon />
                          </IconButton>
                        </span>

                        <Scrollbars
                          className="uploadFilesList"
                          autoHide={false}
                          universal={true}
                          autoHeight={true}
                          autoHeightMin={0}
                          autoHeightMax={60}
                        >
                          {this.state.patientFaceSheets.map((file, key) => (
                            <ListItem className="files-list-item" key={key}>
                              <ListItemText>
                                <div className="files-list-item-content">
                                  <div className="files-list-item-content-item files-list-item-content-item-1">
                                    {file.name}
                                  </div>
                                </div>
                              </ListItemText>
                              <ListItemSecondaryAction>
                                <IconButton
                                  edge="end"
                                  aria-label="delete"
                                  onClick={() =>
                                    this.imageFilesRemoveOne(file, "facesheet")
                                  }
                                >
                                  <DeleteIcon />
                                </IconButton>
                              </ListItemSecondaryAction>
                            </ListItem>
                          ))}
                        </Scrollbars>
                      </List>
                    ) : null}
                  </FormControl>
                </Box>
                <Box width={1 / 2} pl={2} className="upload-links">
                  {this.state.patientUploadHistory &&
                    this.state.patientUploadHistory.length > 0 ? (
                    <List>
                      <div className="form-caption uploaded-docs-caption">
                        Uploaded Documents
                        <Tooltip title="Download all uploaded documents as a zip.">
                          <span>
                            <IconButton
                              size="small"
                              aria-label="Download all uploaded documents"
                              className="uploaded-docs-download"
                              disabled={this.state.downloadingDocs}
                              onClick={this.downloadUploadedDocuments}
                            >
                              {this.state.downloadingDocs ? (
                                <CircularProgress size={14} />
                              ) : (
                                <GetAppIcon style={{ fontSize: 18 }} />
                              )}
                            </IconButton>
                          </span>
                        </Tooltip>
                      </div>
                      <Scrollbars
                        className="uploadFilesList"
                        style={{ height: "60px" }}
                        universal={true}
                      >
                        {this.state.patientUploadHistory.map((file, key) => (
                          <ListItem className="files-list-item" key={key}>
                            <ListItemText>
                              <div className="files-list-item-content">
                                <div className="files-list-item-content-item files-list-item-content-item-1">
                                  {file.uploadName}
                                </div>
                              </div>
                            </ListItemText>
                            <ListItemSecondaryAction>
                              <IconButton
                                edge="end"
                                aria-label="delete"
                                onClick={() => this.deleteImages(file.id)}
                              >
                                <DeleteIcon />
                              </IconButton>
                            </ListItemSecondaryAction>
                          </ListItem>
                        ))}
                      </Scrollbars>
                    </List>
                  ) : null}
                  {this.state.loading ? (
                    <div class="modal_loader">
                      <div class="preloader">
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                        <span class="loader_span"></span>
                      </div>
                    </div>
                  ) : (
                    ""
                  )}
                </Box>
              </Box>
              <Box width={1}>
                <div className={"form-caption"}>Category Criteria</div>

                <FormControl>
                  <Box
                    display="flex"
                    justifyContent="flex-start"
                    flexWrap={"wrap"}
                  >
                    {typeof categoryList === "object" && categoryList.length
                      ? categoryList.map((cList, key) => {
                        const {
                          categoryValue,
                          catagoryId,
                          status,
                          parent,
                        } = cList;
                        if (parent == 0) {
                          return (
                            <Chip
                              key={key}
                              icon={
                                <Checkbox
                                  key={key}
                                  icon={<CircleUnchecked />}
                                  checkedIcon={<CircleCheckedFilled />}
                                  checked={
                                    patientCategories.includes(catagoryId)
                                      ? true
                                      : false
                                  }
                                />
                              }
                              label={categoryValue}
                              onClick={this.selectPatientCategory.bind(
                                this,
                                catagoryId
                              )}
                              className={
                                patientCategories.includes(catagoryId)
                                  ? "chipinput activeCat"
                                  : "chipinput inactiveCat"
                              }
                            />
                          );
                        }
                      })
                      : "No categories available"}
                  </Box>

                  <FormErrors
                    show={!this.state.patientCategotiesValid}
                    formErrors={this.state.formErrors}
                    fieldName="patientCategoties"
                  />
                </FormControl>
              </Box>
            </DialogContent>
            <DialogActions className="modal-actions" justify="center">
              <Button
                type="submit"
                className="btn1"
                disabled={
                  !this.validateForm() ||
                  this.state.loading ||
                  this.state.isUpdating !== false
                }
              >
                {this.state.loading ||
                  (this.state.isUpdating !== false && (
                    <CircularProgress
                      size={24}
                      className="buttonProgress"
                      color="secondary"
                    />
                  ))}
                {this.state.selectedPatientId
                  ? "Update Patient"
                  : "Create Patient"}
              </Button>
              <Button onClick={this.modalClose} className="cancel-link" style={{ color: "white", backgroundColor: "#A9A9A9", padding: "12px", boxShadow:"3px 3px 3px 0px gray" }}>
                Cancel
              </Button>
            </DialogActions>
          </form>
        </Dialog>
        {this.state.loadingPatient ||
          this.state.loading ||
          !this.state.reduxLoadFlag ? (
          <div className="LinearProgress-ref">
            <LinearProgress />
          </div>
        ) : (
          <div className="LinearProgress-ref"></div>
        )}
        {!this.state.openModal &&
          !this.state.bbaCondition &&
          !this.state.termNcondition ? (
          <Box
            display="flex"
            flexDirection="row"
            width={1}
            className="patient-list-page patient-list-page-new"
          >
            <Box pr={1.5} className="left-content-box">
              <div className="left-content-header">
                <Box
                  display="flex"
                  className="divcontainer"
                  mb={2}
                  ref="dropzone"
                >
                  {/* "Patient Directory" is the new design's name for this screen. The count
                      moves onto its own line beneath the title instead of sitting inline. */}
                  <Box pr={1} className="title-box pd-title-box">
                    <h2 className="titlename pd-title">Patient Directory</h2>
                    <div className="show-text pd-subtitle">
                      Showing {totalPatientShowing}/{total} Patient (
                      {selectionCount} selected)
                    </div>
                  </Box>

                  <Box
                    className="action-box patientListFilters"
                    display="flex"
                    flexDirection="row"
                    justifyContent="flex-end"
                  >
                    <Box pl={1} pr={1}>
                      {facilityType && facilityType == MAXMRJ_FACILITY ? (
                        <button
                          className="pointer btn1 pd-btn pd-btn-primary"
                          onClick={this.modalOpen}
                        >
                          {!this.state.selectedPatientId ||
                            this.state.multiPatientMode
                            ? "+ Add New Patient"
                            : "Update Patient"}
                        </button>
                      ) : null}
                      {/* "Import Patient List" removed at the client's request — the nightly PCC
                          import now brings patients in on its own, so the manual trigger is
                          redundant. Commented out rather than deleted: showImportModal and the
                          import modal itself are untouched, so restoring this is one block.

                        <button
                          className="pointer btn1 import_btn pd-btn pd-btn-pink"
                          onClick={this.showImportModal}
                        >
                          Import Patient List
                        </button>
                      */}
                    </Box>
                  </Box>
                  {/* Tabs + search + sort in one bar, per the new design. The tab bar moved here
                      from its own row above the page: same activeTab state, same handleTabChange,
                      rendered as pills instead of MUI Tabs. */}
                  <div className="pd-toolbar">
                    {showTabs ? (
                      <nav className="pd-tabs">
                        {visibleTabs.map((t) => (
                          <button
                            key={t.key}
                            type="button"
                            className={`pd-tab${this.state.activeTab === t.key ? " active" : ""}`}
                            onClick={(e) => this.handleTabChange(e, t.key)}
                          >
                            {t.label}
                          </button>
                        ))}
                      </nav>
                    ) : (
                      <span />
                    )}

                    <div className="pd-toolbar-right">
                      <Box pl={1} pr={1}>
                        <div className="pd-search">
                          <SearchIcon className="pd-search-icon" />
                          <InputBase
                            className="pd-search-input"
                            placeholder="Search patient..."
                            value={this.state.patientSearchKeyword}
                            onChange={this.search}
                            onKeyPress={this.searchReturn}
                          />
                          {/* Reset: only rendered once there is something to clear, so the box
                              is empty-looking when it is empty. Wipes the keyword and refetches
                              unfiltered in one click — typing alone does not refetch, Enter does,
                              so a DP clearing the text by hand would otherwise still see the
                              filtered list until they pressed Enter on an empty box. */}
                          {this.state.patientSearchKeyword ? (
                            <button
                              type="button"
                              className="pd-search-clear"
                              aria-label="Clear search"
                              title="Clear search"
                              onClick={this.clearSearch}
                            >
                              <CloseIcon />
                            </button>
                          ) : null}
                        </div>
                      </Box>
                      <Box pl={1} className="box-filter filter-orderby">
                        <FormGroup>
                          <FormControl className="pd-select-control">
                            <Select
                              id="sorting"
                              color="secondary"
                              name="sorting"
                              className="pd-select"
                              disableUnderline
                              value={sorting}
                              onChange={this.handlePatientSorting}
                              renderValue={(v) => "Order By: " + (PATIENT_ORDERBY[v] || "")}
                            >
                              {PATIENT_ORDERBY
                                ? Object.keys(PATIENT_ORDERBY).map((key) => {
                                  return (
                                    <MenuItem key={key} value={key}>
                                      {PATIENT_ORDERBY[key]}
                                    </MenuItem>
                                  );
                                })
                                : null}
                            </Select>
                          </FormControl>
                        </FormGroup>
                      </Box>
                    </div>
                  </div>
                </Box>

                {/* Every tab: narrow the list to patients whose insurance carries a given
                    insurance type. Same pill design as the Discharged row below; resolved
                    server-side through master_insurance.insurance_type. Hidden until the
                    catalogue loads so an empty row never flashes. */}
                {this.state.insuranceTypeList.length ? (
                  <div className="pd-filter-row">
                    <span className="pd-filter-label">Insurance:</span>
                    <button
                      type="button"
                      className={`pd-filter-btn${this.state.insuranceTypeId === INSURANCE_TYPE_ALL ? " active" : ""
                        }`}
                      onClick={() => this.handleInsuranceTypeFilter(INSURANCE_TYPE_ALL)}
                    >
                      All
                    </button>
                    {this.state.insuranceTypeList.map((t) => (
                      <button
                        key={t.insuranceTypeId}
                        type="button"
                        className={`pd-filter-btn${this.state.insuranceTypeId === t.insuranceTypeId ? " active" : ""
                          }`}
                        onClick={() => this.handleInsuranceTypeFilter(t.insuranceTypeId)}
                      >
                        {t.insuranceTypeName}
                      </button>
                    ))}
                  </div>
                ) : null}

                {/* Discharged tab only: narrow the list to patients discharged in the last
                    N days. Same pill design as the removed STATUS row, but a different
                    filter — this one runs on actual_discharge_date, server-side. */}
                {this.state.activeTab === "DISCHARGED" ? (
                  <div className="pd-filter-row">
                    <span className="pd-filter-label">Discharged:</span>
                    {DISCHARGED_WITHIN_FILTERS.map((f) => (
                      <button
                        key={f.days}
                        type="button"
                        className={`pd-filter-btn${this.state.dischargedWithinDays === f.days ? " active" : ""
                          }`}
                        onClick={() => this.handleDischargedWithinFilter(f.days)}
                      >
                        {f.label}
                      </button>
                    ))}
                  </div>
                ) : null}

              </div>

              <Box
                width={1}
                className="left-content-list left-content-list-New"
              >
                <div className="PatientList">
                  <Scrollbars
                    className="patientlist-scroll"
                    style={{ height: "calc(100vh - 156px)" }}
                    universal={true}
                    autoHide={false}
                  >
                    {patientList &&
                      typeof patientList === "object" &&
                      patientList.length ? (
                      <InfiniteScroll
                        pageStart={0}
                        loadMore={this.loadMorePatient}
                        threshold={50}
                        hasMore={this.state.loadMore}
                        loader={
                          <div className="loader" key={0}>
                            Loading ...
                          </div>
                        }
                        useWindow={false}
                        getScrollParent={() => this.scrollParentRef}
                        style={{ width: "calc(100% - 16px)" }}
                      >
                        {patientList.map((pList, key) => {
                          return (
                            <Box
                              width={1}
                              key={key}
                              display="flex"
                              flexDirection="row"
                              mb={1}
                              className={
                                selectedPatientId == pList.patientId
                                  ? "selectedPatient"
                                  : ""
                              }
                            >
                              {/* Checkbox lives INSIDE the card in the new design, not beside
                                  it — so the card is the full width of the list and the tick
                                  sits on the card's own left edge. */}
                              <div
                                className={`list-item-content ${selectedPatientId == pList.patientId ||
                                  this.state.multiplePatientList.includes(
                                    pList.patientId
                                  )
                                  ? "selectedlist"
                                  : ""
                                  }`}
                              >
                                <div className="list-item-checkbox">
                                  <CustomTooltip
                                    arrow
                                    placement="top"
                                    title="Multi-select patients to send a bundled referral"
                                  >
                                  <Checkbox
                                    className="check-input"
                                    // Ticked only by clicking the box itself. This used to also
                                    // tick when selectedPatientId matched — which any click on
                                    // the row sets, via fetchPatientInfo — so clicking blank
                                    // space in the card appeared to check the patient.
                                    // multiplePatientList is the box's own list:
                                    // fetchPatientList maintains it and clears selectedPatientId.
                                    checked={this.state.multiplePatientList.includes(
                                      pList.patientId
                                    )}
                                    onChange={() =>
                                      this.fetchPatientList(
                                        pList.patientId,
                                        pList
                                      )
                                    }
                                  />
                                  </CustomTooltip>
                                </div>
                                {this.patientListRender(pList, key)}
                              </div>
                            </Box>
                          );
                        })}
                      </InfiniteScroll>
                    ) : this.state.loadingPatient ? (
                      <div className="no-data-div">
                        <div>Loading...</div>
                      </div>
                    ) : (
                      <div className="no-data-div">
                        {" "}
                        <div>No patient found </div>
                      </div>
                    )}
                  </Scrollbars>
                </div>
              </Box>
            </Box>

            <Box pl={1.5} className="right-box-cover">
              <CategoriesList
                patientCategoryList={patientCategoryList}
                loading={loading}
                patientName={patientName}
                patientId={selectedPatientId}
                multiPatientMode={this.state.multiPatientMode}
                facilityType={facilityType}
                openPatientPopup={this.openPatientPopup}
              />
              <TasksList
                tasks={tasks}
                loading={loading}
                patientName={patientName}
                patientId={selectedPatientId}
                patientDetail={this.state.selectedPatientData}
                updatePatient={this.fetchPatientInfo}
                patientTaskGroup={this.state.patientTaskGroup}
                multiPatientMode={this.state.multiPatientMode}
              />
            </Box>
          </Box>
        ) : null}
      </div>
    );
  }
}
export const PatientList = connect(
  mapStateToProps,
  mapDispatchToProps
)(PatientListClass);
export default PatientList;
